import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { push, goBack as goBackRouter, replace } from 'connected-react-router';
import './../../assets/ak-cached/24h/css/App.css';
import ModalOverlay from './../../components/modalOverlay';
import SignInMHVerification from '../buildProduct/signInMHVerification';
import * as actionn from './../../action/buildProduct'
import { CallMe } from './callMe';
import Faq from './faq';
import Save from './save';
import Cart from './../cart/index';
import * as action from './../../action/modalWindow';
import * as saveAction from './../../action/save';
import * as cartAction from './../../action/cart';
import { TextLink, Button } from '@vds/buttons';
import { SweetnerMsg, updateVZCCouponNotificationMsg, updateFireAlarmDetails } from './../../action/buildProduct';
import { SweetnerMsgMFRT } from './../../action/loopQual';
import { connect } from 'react-redux'
import { withCookies } from 'react-cookie';
import { ModalWindow, Pages, OfferTypes } from './../../constants/actionType';
import { MHQualified, MHNQualified, MHNADDITIONALOFFER } from './../buildProduct/helperContent';
import { updateSCTags, tempSCData, updateSCcustomEvent, getProductObject } from './../../service/dtmTag';
import { updateVzdlSCCustomEvent, tempVzdlSCData, updateSaveCartEmail } from './../../service/vzdl';
import GlobalChat from './../../components/globalChat';
import MP, { MP_const } from './../../constants/espanol';
import { logoutSmartSave } from './../../action/error';
import { detectClient } from '../../util/detectClient';
import { detailsInfo, logOtherInfo } from './../../service/logService';
import MovesCart from './../nsCart/index';
import { InHomeUtils } from './../../util/inhomeUtils';
import { Body } from '@vds/typography';
import { Tooltip } from '@vds/tooltips';
import styled from 'styled-components';
import CloseIcon from '@vds/icons/close';
import { ModalTitle, ModalBody } from '@vds/modals';
import Iframe from 'react-iframe';
import { VZMobileBanner } from '../midnight/DiscountFlowModal';
import { checkIfMidnite } from '../midnight/services/prodTileService';
import {MNHSIGNINOVERLAY} from './../../containers/buildProduct/mnhSignin';
import { Modal } from '@vds/modals';
import * as modalAction from './../../action/modalWindow';
import * as buildProductaction from '../../action/buildProduct'
import {store} from './../../index'
import OrderSummary from '../cart/orderSummary';
import MainSubHeader from './MainSubHeader';


const StyledFAQ = styled.section`
.FAQ, .Save{
    padding: 0px 0px 0px 8px;
}
`;

const StyledTooltipDiv = styled.div`
    width: 224px;
    padding: 12px 25px 12px 12px;
    margin-right: 4px;
    border-radius: 4px;
    color: #000;
    background-color: white;
    text-align: left;
    position: absolute;
    transform: translate(-40%, 8%);
    border: 1px solid #000;
    border-top-color: #fff;
    z-index: 999999;
    & > .signIncloseIcon {
        position: absolute;
        top: 12px;
        right: 10px;
    }

@media only screen and (max-width: 767px) {
    width: 188px;
}
`;
const StyledTooltipIcon = styled.div `
    left: 45%;
    margin-top: 6px;
    position: absolute;
    width: 12px;
    height: 12px;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    border-bottom-color: transparent;
    border-left-color: transparent;
    background-color: rgb(255, 255, 255);
    z-index: 999999;
`;

class Header extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            day: '',
            hour:'',
            min:'',
            sec:'',
            showtooltip: true,
            showPopularPlanBanner: false,
            signinClick: false,
            closeModal: false
          }
          this.isReskin = true;
          this.linkRef=React.createRef();
        //   this.PPSignInOverlay = PPSigninOverlay.bind(this);
        //   this.isMonarch = this.props?.runtimeKey?.enableMidnite?.toUpperCase() === 'Y' || this.props?.isMonarchView || this.props.buildProduct?.isMNEnabled;
        this.isMonarch = this.props.isMonarchView ? this.props.isMonarchView : (this.props.buildProduct.isMNEnabled && this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.enableMidnite?.toUpperCase() === 'Y' || true);
    }

    // Rerending component for displaying Monarch header when runtimeKeys is fetched
    // shouldComponentUpdate = nextProps => {
    //     if((nextProps?.isMonarchView !== this.props?.isMonarchView) || (nextProps?.buildProduct?.isMonarchView !== this.props.buildProduct?.isMonarchView)) {
    //         if(this.props.lqState.runtimeKey?.enableMidnite?.toUpperCase() === 'Y') {
    //             this.isMonarch = true;
    //         }
    //         return true;
    //     }
    //     return false;
    // }


    componentDidUpdate(prevProps,prevState){
        if(prevState.showPopularPlanBanner !== this.state.showPopularPlanBanner && this.state.showPopularPlanBanner === false){
            setTimeout(()=>{
            const element = document.getElementById("detailsRef")
            if( this.linkRef.current ){
                    this.linkRef.current.focus();
                    element.addEventListener('focus',()=>{
                            element.style.outline = 'none !important';
                            element.style.boxShadow = '0px 0px 0.3rem 0.25rem #109EE0';
                    })
            }
            else{
                element.addEventListener('blur',()=>{
                    element.style.outline = 'none !important';
                    element.style.boxShadow = 'none !important';
            })
            }
        },0)
        }
        if(this.props?.buildProduct?.enableSaveCartStickyMobile){
            action.openModalWindow('SAVE_MOBILE', this.props.dispatch);
            this.props.dispatch({type:'ENABLE_SAVECART_STICKY_MOBILE', value:false}); 
        }

        
        if((this.props?.buildProduct?.stickyheaderfooter && this.props?.appState.flowType !== 'MV' &&  this.props?.appState.flowType !== 'SUPP') || ((this.props?.appState?.flowType ==='MV'  && this.props?.buildProduct?.movesstickyheaderfooter && this.props?.lqState && this.props?.lqState?.runtimeKey && this.props?.lqState?.runtimeKey?.enableMovesStickyHeaderFooter === 'Y')) ){
            document.getElementById("fiosHeaderLq").style.position = "relative";
        }
        else if((this.props?.appState?.flowType ==='MV'  && !this.props?.buildProduct?.movesstickyheaderfooter && this.props?.lqState && this.props?.lqState?.runtimeKey && this.props?.lqState?.runtimeKey?.enableMovesStickyHeaderFooter === 'Y')){
            document.getElementById("fiosHeaderLq").style.position = "sticky";
        }

        
        
    }

   
  
    validateSignin = (mtn,zip)=>{
        updateSCTags("validate");
        //updateTNInfo(this.props.dispatch, "PH1", mtn);
        this.props.dispatch({
            type:'UPDATE_MNH_DETAILS',
            value: {mtn: mtn, zip: zip}
          })
        let addrID = (this.props.lqState.selectedUnit !== null
            && this.props.lqState.selectedUnit.addressId !== undefined
            && this.props.lqState.selectedUnit.addressId !== null
            && this.props.lqState.selectedUnit.addressId !== ""
            && this.props.lqState.selectedUnit.addressId !== "N") ? this.props.lqState.selectedUnit.addressId : this.props.lqState.selectedAdr.addressID;
        
        if (addrID === undefined || addrID === null || addrID === '') {
            if (this.props.xpsEntry !== undefined && this.props.xpsEntry !== null
                && this.props.xpsEntry.retrieveSmartCart) {
                addrID = this.props.xpsEntry.retrieveSmartCart.addressID;
            }
        }

        buildProductaction.validateMtnBP(mtn, this.props.visitId, addrID,this.props.dispatch,zip, this.props.buildProduct, this.props.modalWindow);
        this.setState({closeModal: true});
        modalAction.closeModalWindow(this.props.modalWindow.modalId, this.props.dispatch, '', false);
        // modalAction.openModalWindow("mnhPushNotificationOverlay", this.props.dispatch);
    }

    getTimer = () =>
    {   
        try{
            if(this.props.lqState && this.props.lqState.runtimeKey && this.props.runtimeKey.showHolidaytimer && this.props.lqState.runtimeKey.showHolidaytimer == "Y"){          
        var gendate = this.props.runtimeKey && this.props.runtimeKey.Holidaytimer ? this.props.runtimeKey.Holidaytimer : "Jun 15, 2022 23:59:00";
        var enddate = new Date(gendate).getTime();
        var endoffset = -5;
        var enddatenytime = enddate;
        var d = new Date();
        var localltime = d.getTime();
        var localoffset = d.getTimezoneOffset() * 60000;
        var utc = localltime + localoffset;
        var offset = -5;
        var nytime = utc + (3600000 * offset);
        var distance = enddatenytime - nytime;
        //console.log('now'+ now+'countDownDate'+countDownDate+"distance->"+distance);
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        this.setState({day : days,hour:hours,min:minutes,sec:seconds});
        // If the countdown is over, write some text 
        if (distance < 0) {
           // clearInterval(x);
            this.setState({day : '',hour:'',min:'',sec:''});
    }
}}catch(error){
    /**console error */
    //console.log(error)
}
}
    handleKeyDown(e) {
        if (e.keyCode === 13 || e.keyCode === 32) {
            this.onOpenModal(e);
            e.preventDefault();
        }
    }

    handleSignInKeyDown(e) {
        if (e.keyCode === 13 || e.keyCode === 32) {
            this.onClickSignInCTA(e);
            e.preventDefault();
        }
    }

    onOpenModal = (e) => {
        let targetId = e?.target?.id;
        let id = e?.target?.closest('.promo-ribbo ')?.id;
        if (!targetId && (e?.target?.title === 'icon') || (id)) {
            targetId = e?.target?.parentElement?.id ? e?.target?.parentElement?.id : id
        }
        if(this.props.buildProduct && this.props.buildProduct.emergencyServices && this.props.buildProduct.emergencyServices.selectedProduct){
            updateFireAlarmDetails(this.props.appState.visitId, this.props.buildProduct.emergencyServices);
        }
        if (targetId) {
            action.openModalWindow(targetId, this.props.dispatch);
            if (targetId === 'SAVE' || targetId === 'SAVE_MOBILE') {
                let isCreditCompleted = false;
                let saveLQEmailInfo = "";
                if ((this.props.creditCheckResponse && this.props.creditCheckResponse !== null)||(InHomeUtils.isNotNull(this.props.save.retrieveSmartCart) && InHomeUtils.isNotNull(this.props.save.retrieveSmartCart.creditCheckCompleted) && this.props.save.retrieveSmartCart.creditCheckCompleted)||(InHomeUtils.isNotNull(this.props.save.saveResponse) && InHomeUtils.isNotNull(this.props.save.saveResponse.creditCheckCompleted) && this.props.save.saveResponse.creditCheckCompleted)) {
                    if (this.props.save && this.props.save.saveModalInput === '') {
                        this.props.save.saveModalInput = this.props.personalInfo.eMailId;
                    }
                    isCreditCompleted = true;
                    saveAction.creditDone(true, this.props.dispatch);
                }
                if (this.props.save && InHomeUtils.isNotEmpty(this.props.save.saveLqEmailInput)) {
                    saveLQEmailInfo = this.props.save.saveLqEmailInput;
                }
                if (this.props.save && this.props.save.issmartcartflow) {
                    if (this.props.save.retrieveSmartCart !== null && (InHomeUtils.isNotEmpty(this.props.save.retrieveSmartCart.email) || InHomeUtils.isNotEmpty(this.props.save.retrieveSmartCart.mtn))) {
                        saveAction.saveModalInput(this.props.dispatch, InHomeUtils.isNotEmpty(this.props.save.retrieveSmartCart.email) ? this.props.save.retrieveSmartCart.email : this.props.save.retrieveSmartCart.mtn);
                    } else if (this.props.save.saveResponse !== null && (InHomeUtils.isNotEmpty(this.props.save.saveResponse.email) || InHomeUtils.isNotEmpty(this.props.save.saveResponse.mtn))) {
                        saveAction.saveModalInput(this.props.dispatch, InHomeUtils.isNotEmpty(this.props.save.saveResponse.email) ? this.props.save.saveResponse.email : this.props.save.saveResponse.mtn);
                    }
                }

                if (this.props.save && !this.props.save.helpSave && !this.props.save.save_Invoked && !isCreditCompleted) {
                    tempSCData.detailPageName = "smart cart save proactive| no email or mtn|" + ((isCreditCompleted) ? " post credit" : " pre credit");
                    tempVzdlSCData.detail = "smart cart save proactive - no email or mtn -" + ((isCreditCompleted) ? " post credit" : " pre credit");
                }
                else if (this.props.save && (this.props.save.save_Invoked || isCreditCompleted)) {
                    if (isCreditCompleted) {
                        saveAction.smartCartSaveWithParam(this.props.dispatch, this.props.appState.visitId, this.props.save.saveModalInput, false, this.props.appState.mon_no, isCreditCompleted, saveLQEmailInfo, this.props.lqState);
                    }
                    tempSCData.detailPageName = "smart cart confirmation| " + ((isCreditCompleted) ? " post credit" : " pre credit");
                    tempVzdlSCData.detail = "smart cart confirmation - " + ((isCreditCompleted) ? " post credit" : " pre credit");
                }
                tempSCData.events = "event5,event22";
                tempSCData.product = getProductObject(this.props.cartOrderDetail, this.props.cartResponse);

                if (this.props.save && this.props.save.issmartcartflow && !this.props.save.helpSave && !this.props.save.save_Invoked) {
                    updateSCcustomEvent("resave", "ddPageViewUpdateEvent", "");
                    updateVzdlSCCustomEvent("resave", "pageViewOmni", "")
                }
                else {
                    updateSCcustomEvent("saveProactive", "ddPageViewUpdateEvent", "detailPageName,events");
                    updateVzdlSCCustomEvent("saveProactive", "pageViewOmni", "detail")
                }
            }
            if (this.props.appState && this.props.moveState && this.props.appState.flowType === "MV" && this.props.moveState.moveLandingExp.movesEligibility === "SEAMLESS") {
                tempSCData.customerCategory = "^Moves^";
                tempSCData.contentChannel = "/vz/residential/order/prospect accord seamless move/faq";
                tempSCData.detailPageName = "movers faq";
                tempSCData.events = "event5,event12,prodView";
                updateSCcustomEvent("faq", "ddAddToCartEvent", "detailPageName,contentChannel,events");
                const pathname = window.location.pathname;
                    if(InHomeUtils.isNotNull(pathname) && pathname.includes('checkout')){
                        tempVzdlSCData.name = "checkout";
                        updateVzdlSCCustomEvent("faq", "pageViewOmni","name");
                    }
                    else if(InHomeUtils.isNotNull(pathname) && pathname.includes('landing')){
                        tempVzdlSCData.name = "landing";
                        updateVzdlSCCustomEvent("faq", "pageViewOmni","name");
                    }
                    else{
                        updateVzdlSCCustomEvent("faq", "pageViewOmni", "");
                    }
            }
            else if (this.props.appState && this.props.moveState && this.props.appState.flowType === "MV" && this.props.moveState.moveLandingExp.movesEligibility === "NONSEAMLESS") {
                tempSCData.customerCategory = "^Moves^";
                tempSCData.contentChannel = "/vz/residential/order/prospect accord move/faq";
                tempSCData.detailPageName = "movers faq";
                updateSCcustomEvent("faq", "ddAddToCartEvent", "detailPageName,contentChannel");
                const pathname = window.location.pathname;
                    if(InHomeUtils.isNotNull(pathname) && pathname.includes('checkout')){
                        tempVzdlSCData.name = "checkout";
                        updateVzdlSCCustomEvent("faq", "pageViewOmni","name");
                    }
                    else if(InHomeUtils.isNotNull(pathname) && pathname.includes('landing')){
                        tempVzdlSCData.name = "landing";
                        updateVzdlSCCustomEvent("faq", "pageViewOmni","name");
                    }
                    else{
                        updateVzdlSCCustomEvent("faq", "pageViewOmni", "");
                    }
            }
            else {
                if (targetId === 'FAQ' || targetId === 'FAQ_MOBILE') {
                    updateSCTags("faq");
                    updateSCcustomEvent("faq", "ddAddToCartEvent", "");
                    const pathname = window.location.pathname;
                    if(InHomeUtils.isNotNull(pathname) && pathname.includes('checkout')){
                        tempVzdlSCData.name = "checkout";
                        updateVzdlSCCustomEvent("faq", "pageViewOmni","name");
                    }else if(InHomeUtils.isNotNull(pathname) && pathname.includes('popularPlans')){
                        tempVzdlSCData.name = "popular plans";
                        updateVzdlSCCustomEvent("faq", "pageViewOmni","name");
                    }
                    else{
                        updateVzdlSCCustomEvent("faq", "pageViewOmni", "");
                    }
                }
                if(targetId === 'signInCTA') {
                    updateSCTags("sign in header");
                }
            }
        }
    }

    fiosReferralHandleEsponolKeyDown = (e) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            this.fiosReferralEspanolClick()
        }
    }

    handleEsponolKeyDown = (e) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            if (window.location.hostname === "espanol.verizon.com" || window.location.hostname === "espanolstage.verizon.com") {
                this.espanolDomainClick()
            }
            else {
                this.espanolClick()
            }
        }
    }

    swtichLang = (e) => {
        if(window.location.hostname === "espanol.verizon.com" || window.location.hostname === "espanolstage.verizon.com"){
            window.location.replace('https://www.verizon.com/inhome/fiosreferral');
        }else{
            window.location.replace('https://espanol.verizon.com/inhome/fiosreferral');
        }
    }

    fiosReferralEspanolClick = () => {
        if (sessionStorage.getItem("fiosReferralFlow") === "true" && window?.location?.href?.includes('fiosreferral')) {
            try {
                InHomeUtils.clearMemory();  
              } catch(ex) {
                //console.log(ex);
              }  finally {
                localStorage?.clear();
                sessionStorage?.clear();      
                if (window.location.host === 'www98.verizon.com' || window.location.host === 'localhost:3000') {
                  window.location.href = Pages.spanishfiosURLStage;
                } else if (window.location.host === 'www.verizon.com') {
                    window.location.href = Pages.spanishFiosURLPROD;
                } else if (window.location.host === 'espanolstage.verizon.com') {
                    window.location.replace(Pages.fiosURLStage);
                  } else if (window.location.host === 'espanol.verizon.com') {
                    window.location.replace(Pages.fiosURLPROD);
                  }
              }
        }
    }



    espanolClick = () => {  
        //let value = window.sessionStorage.getItem('persist:root');
        let visit_id = MP.getCookie('visit_id');
        //let arrayVal='';   let arrayValtemp='';   
        let visitor_id = MP.getCookie('visitor_id');
        //let data = '';
        let relativePath = sessionStorage.getItem("fiosReferralFlow") === "true" ? '/inhome/fiosreferral' : '/inhome/qualification';

        //let pathName = window.top.location.pathname;//this.props.history.location.pathname;
    
        let SrcURL = ''
        let locHost = window.location.host;
        let domainURL = locHost === 'www98.verizon.com' || locHost === 'wwwnte1aws.ebiz.verizon.com' || locHost.indexOf('localhost') > -1 ? 'https://espanolstage.verizon.com' : 'https://espanol.verizon.com';
        let locPathName = window.location.pathname;
        if (locHost === 'www.verizon.com'
            || locHost === 'www98.verizon.com'
            || locHost === 'localhost:3000' || locHost === 'wwwnte1aws.ebiz.verizon.com') {
            if (relativePath === locPathName) {
                if (window.location.search)
                    SrcURL = encodeURIComponent(domainURL + locPathName + window.location.search);
                else
                    SrcURL = encodeURIComponent(domainURL + locPathName)
            }
            else if(locPathName==='/inhome/brtc'){
                SrcURL = encodeURIComponent(domainURL + locPathName + window.location.search);
            }
            else {
                if(window.location.search){
                    SrcURL = encodeURIComponent(domainURL + locPathName + window.location.search);
                }else if(locPathName){
                    SrcURL = encodeURIComponent(domainURL + locPathName);
                }else{
                    SrcURL = encodeURIComponent(domainURL + relativePath);
                }
            }
            let persitCookieSet = MP.getCookie('persitsetitem');
            if (persitCookieSet !== undefined && persitCookieSet !== null && persitCookieSet === "Y") {
                if (window.location.search)
                    SrcURL = encodeURIComponent(domainURL + locPathName + window.location.search);
                else
                    SrcURL = encodeURIComponent(domainURL + locPathName);
            }
            else if ((typeof MP !== 'undefined') && (typeof MP.setCookie !== 'undefined') && persitCookieSet !== "Y") {
                //MP.setCookie('persitsetitem', 'Y', '/', domain);
                // document.cookie(ckname, 'persitsetitem', { domain: '.verizon.com', httpOnly: httponly, secure: true, encode: String, maxAge: 1000 * 60 * 60 * 24 * expirydays });
                window.sessionStorage.setItem('persist:root', "")
            }
        }
        //MP_const.SrcUrl=unescape('https%3A%2F%2Fwww.verizon.com%2Finhome%2Fqualification');
        MP_const.SrcUrl = unescape(SrcURL);
        MP.SrcUrl = unescape(SrcURL);
        //MP.UrlLang='es';
        MP.UrlLang = 'mp_js_current_lang';
        MP.init();
        return MP_const.switchLanguage('es', visit_id, visitor_id);
    }

    espanolDomainClick = () => {   
        //let value = window.sessionStorage.getItem('persist:root');
        //let arrayVal=''; let arrayValtemp='';          
        let visit_id = MP.getCookie('visit_id');
        let visitor_id = MP.getCookie('visitor_id');
        //let data = '';
        let relativePath = sessionStorage.getItem("fiosReferralFlow") === "true" ? '/inhome/fiosreferral' : '/inhome/qualification';

        let SrcURL = ''
        // let domainURL = 'https://' + DOMAINS.PROD; // To avoid motion point team not to make it change domain while converting
        let domainURL = 'https://www.verizon.com'; 
        let locHost = window.location.host;
        let locPathName = window.location.pathname;
        if (sessionStorage.getItem("fiosReferralFlow") === "true") {
            if (locHost === 'espanol.verizon.com') {
                // domainURL = 'https://' + DOMAINS.PROD;
                domainURL = 'https://www.verizon.com';
            } else if (locHost === 'espanolstage.verizon.com') {
                domainURL = 'https://' + DOMAINS.STAGE;
            }
        }
        if (locHost === 'espanol.verizon.com' || locHost === 'espanolstage.verizon.com') {
            if (relativePath === locPathName) {
                if (window.location.search)
                    SrcURL = encodeURIComponent(domainURL + locPathName + window.location.search);
                else
                    SrcURL = encodeURIComponent(domainURL + locPathName)
            }
            else if(locPathName==='/inhome/brtc'){
                SrcURL = encodeURIComponent(domainURL + locPathName + window.location.search);
            }
            else {
                if(window.location.search){
                    SrcURL = encodeURIComponent(domainURL + locPathName + window.location.search);
                }else if(locPathName){
                    SrcURL = encodeURIComponent(domainURL + locPathName);
                }else{
                    SrcURL = encodeURIComponent(domainURL + relativePath);
                }
            }
            let persitCookieSet = MP.getCookie('persitSetItem');
            if (persitCookieSet !== undefined && persitCookieSet !== null && persitCookieSet === "Y") {
                if (window.location.search)
                    SrcURL = encodeURIComponent(domainURL + locPathName + window.location.search);
                else
                    SrcURL = encodeURIComponent(domainURL + locPathName);
            }
            else if ((typeof MP !== 'undefined') && (typeof MP.setCookie !== 'undefined') && persitCookieSet !== "Y") {
                // MP.setCookie('persitSetItem', 'Y', '/', domain);                        
                window.sessionStorage.setItem('persist:root', "")
            }
        }
        //MP_const.SrcUrl=unescape('https%3A%2F%2Fwww.verizon.com%2Finhome%2Fqualification');
        MP_const.SrcUrl = unescape(SrcURL);
        MP.SrcUrl = unescape(SrcURL);
        MP.UrlLang = 'es';
        MP.init();
        return MP_const.switchLanguage('en', visit_id, visitor_id);
    }

    shopDeals = () => {
        updateSCTags("back to home");
        action.closeModalWindow(this.props.modalWindow.modalId, this.props.dispatch);
        window.location.href = Pages.VzHome;
    }

    homeClick = (e, vendorVZLogo, flowType = null) => {
        updateSCTags("back to home")
        logOtherInfo(detailsInfo('Verizonlogo', this.props.appState.visitId, 'homeClick', "VzLogoClicked", "LQAction"));
        if (this.props.lqState.TWSlq2){
            let scope = '';
            if(this.props.lqState.mfrtType ==='medical_new' || this.props.lqState.mfrtType ==='medical'){
                scope = 'medical';
            }else if(this.props.lqState.mfrtType === 'milvet' || this.props.lqState.mfrtType === 'military'){
                scope = 'milvet'
            }else {
                scope = this.props.lqState.mfrtType;
            }
            window.location.href = Pages.VzHome + '?type=' + scope;
        }
        else if (!vendorVZLogo && flowType !== "SUPP") {
            window.location.href = Pages.VzHome;
        } else if (flowType === "SUPP") {
            window.location.href = Pages.MyVzDashboard;
        } else if (this.props.appState.vendor.vendorUrl !== undefined && this.props.appState.vendor.vendorUrl !== null && this.props.appState.vendor.vendorUrl !== "") {
            window.location.href = Pages.VzHome;//tmep fix once url coming from backend need to update it
            //window.location.href= this.props.appState.vendor.vendorUrl;
        }
    }

    vendorClick = (e, isTargetOrdering) => {
        if (this.props.appState && this.props.appState.vendor && this.props.appState.vendor.vendorUrl !== "" && !isTargetOrdering) {
            if (InHomeUtils.isNotNull(this.props.appState.vendor) && this.props.appState.vendor.vendorName === "RedVentures" && this.props.appState.referralUrl && this.props.appState.referralUrl !== "") {
                if (this.props.appState.referralUrl.toLowerCase().includes("inhome/qualification")) { //case where it redirects to oneLQ flow referrer url i s bau inhome/qualification
                    window.location.href = this.props.appState.vendor.vendorUrl;
                }
                else {
                    window.location.href = this.props.appState.referralUrl;
                }
            }
            else {
                window.location.href = this.props.appState.vendor.vendorUrl;
            }
        }
    }

    onCloseModal = (e) => {
        if (this.props.modalWindow && this.props.modalWindow.modalId === 'SAVE') {
            if (this.props.save && this.props.save.issmartcartflow) {
                updateSCTags("continue shopping");
            }
            else {
                updateSCTags("continue without saving");
            }
        }
        if (this.props.modalWindow && this.props.modalWindow.modalId === ModalWindow.ids.footerLearn) {
            updateSCTags("got it");
        }
        action.closeModalWindow(this.props.modalWindow.modalId, this.props.dispatch);
    }

    onSaveClick = () => {
        updateSCTags("save cart");
        updateSaveCartEmail();
        // tempSCData.detailPageName = "smart cart save proactive| no email or mtn|" + ((isCreditCompleted) ? " post credit" : " pre credit");
        // tempSCData.events="event5,event22";
        // tempSCData.product = getProductObject(this.props.cart.cartOrderDetail,this.props.cart.cartResponse);
        // updateSCcustomEvent("saveProactive","ddPageViewUpdateEvent","detailPageName,events") ;         
        let pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        let isMTN = false;
        let cardNum = this.props.save && this.props.save.saveModalInput?this.props.save.saveModalInput:"";
        //let mtn = "";
        let isCreditCompleted = false;
        let saveLQEmailInfo = "";
       /* if (cardNum !== '') {
            isMTN = !isNaN(cardNum.substring(0, 2)) && !isNaN(cardNum.substring(4, 6));
        } */
        if (this.props.save && !this.props.save.issmartcartflow && cardNum === "") {
            saveAction.validateInput(true, this.props.dispatch);
        }
        else if (this.props.save && !this.props.save.issmartcartflow && InHomeUtils.isNotEmpty(cardNum)&& !pattern.test(cardNum) && !isMTN) {
            saveAction.validateInput(false, this.props.dispatch);
            saveAction.mtnError(false, this.props.dispatch);
            saveAction.emailError(true, this.props.dispatch);
        }
       /* else if (isMTN && cardNum.length !== 10) {
            saveAction.validateInput(false, this.props.dispatch);
            saveAction.emailError(false, this.props.dispatch);
            saveAction.mtnError(true, this.props.dispatch);
        } */
        else {
            // if (isMTN) {
            //     mtn = cardNum;
            // }
            saveAction.validateInput(false, this.props.dispatch);
            saveAction.emailError(false, this.props.dispatch);
            saveAction.mtnError(false, this.props.dispatch);

            if ((this.props.creditCheckResponse && this.props.creditCheckResponse !== null)||(InHomeUtils.isNotNull(this.props.save.retrieveSmartCart) && InHomeUtils.isNotNull(this.props.save.retrieveSmartCart.creditCheckCompleted) && this.props.save.retrieveSmartCart.creditCheckCompleted)||(InHomeUtils.isNotNull(this.props.save.saveResponse) && InHomeUtils.isNotNull(this.props.save.saveResponse.creditCheckCompleted) && this.props.save.saveResponse.creditCheckCompleted)) {
                if (this.props.save.saveModalInput === '') {
                    this.props.save.saveModalInput = this.props.personalInfo.eMailId;
                }
                isCreditCompleted = true;
                saveAction.creditDone(true, this.props.dispatch);
            }
            if (this.props.save && this.props.save.saveLqEmailInput && InHomeUtils.isNotEmpty(this.props.save.saveLqEmailInput)) {
                saveLQEmailInfo = this.props.save.saveLqEmailInput;
            }
            if (this.props.save && this.props.save.issmartcartflow && InHomeUtils.isNotNull(this.props.save.saveModalInput)&& !InHomeUtils.isNotEmpty(this.props.save.saveModalInput)) {
                saveAction.validateInput(true, this.props.dispatch);
            }
            else if (this.props.save && this.props.save.issmartcartflow && InHomeUtils.isNotNull(this.props.save.saveModalInput) && InHomeUtils.isNotEmpty(this.props.save.saveModalInput) &&!pattern.test(this.props.save.saveModalInput) && !isMTN) {
                saveAction.validateInput(false, this.props.dispatch);
                saveAction.mtnError(false, this.props.dispatch);
                saveAction.emailError(true, this.props.dispatch);
            }
            else {
                saveAction.validateInput(false, this.props.dispatch);
                saveAction.emailError(false, this.props.dispatch);
                saveAction.mtnError(false, this.props.dispatch);
                saveAction.smartCartSaveWithParam(this.props.dispatch, this.props.appState.visitId, this.props.save.saveModalInput, isMTN, this.props.appState.mon_no, isCreditCompleted, saveLQEmailInfo, this.props.lqState, this.props?.buildProduct?.mnhMobileNumber, this.props?.buildProduct );

            }

            }
    }

    validateIpt = (e) => {
        saveAction.saveModalInput(this.props.dispatch, e.target.value);
        let pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
            if(pattern.test(e.target.value)) {
                saveAction.emailError(false, this.props.dispatch);
                updateSCTags("email address entered");
            }
            else{
                saveAction.emailError(true, this.props.dispatch);
            }
    }

    mobileHelp = () => {
        cartAction.mobileHelpReveal(this.props.appState.mobileHelpReveal, this.props.dispatch);
        if (this.props.isCartOpen) {
            cartAction.cartToggle("", this.props.dispatch, this.props.appState.visitId,this.props.buildProduct)
        }
    }

    componentWillUnmount() {
        let count = window.localStorage.getItem('count');
        count = parseInt(count);
        count && --count;
        window.localStorage.setItem('count', count);
        // if(!count){
        //InHomeUtils.clearMemory(); on window close
        // }

    }

    componentDidMount = () => {
        this.props.dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        let count = window.localStorage.getItem('count');
        count = parseInt(count);
        if (!count) {
            window.localStorage.setItem('count', 1);
        } else {
            ++count;
            window.localStorage.setItem('count', count);
        }

        const isMidnight = checkIfMidnite(this.props.lqState);
        if(isMidnight) {
            this.props.dispatch({ type: 'ENABLE_MONARCH_VIEW', value: true });
        }

        document.body.style.overflowY="";
        //initially hide focus outline
        window.document.body.classList.add(this?.props?.lqState?.streamlineLQ ?'hide-focus-outline-streamline':'hide-focus-outline');


        window.document.onkeydown = (e) => {
            //enable focus outline when tabbing
            let bodyClassList = window.document.body.classList;
            (bodyClassList.contains('hide-focus-outline')) && (e.keyCode === 9) && bodyClassList.remove('hide-focus-outline');
        };

        window.document.onmousedown = (e) => {
            //disable focus outline on mouse click
            let bodyClassList = window.document.body.classList;
            (!bodyClassList.contains('hide-focus-outline')) && bodyClassList.add('hide-focus-outline');
        };
        window.MP = MP;
        if ((window.location.search.indexOf("TargetOrdering=Y") > -1 || this.props.appState.isTargetOrdering) && document.getElementById("TargetOrdering") === null) {
            var input = document.createElement("input");
            input.setAttribute("type", "hidden");
            input.setAttribute("name", "TargetOrdering");
            input.setAttribute("id", "TargetOrdering");
            input.setAttribute("value", "Y");
            document.getElementsByTagName("head")[0].appendChild(input);
        }

        //update font-size of input fields (iOS auto-zoom)
        let currClient = detectClient();
        if (currClient.deviceType && ((currClient.deviceType === 'iphone') || (currClient.deviceType === 'ipad'))) {
            if (!document.body.classList.contains('device-ios')) {
                document.body.classList.add('device-ios');
            }
        }
        if (window.location.pathname.indexOf('/change/') > -1) {
            this.props.appState.ecHeader === 'Loading...' && saveAction.getHTMLContent(this.props.dispatch, true);
            this.props.appState.ecFooter === 'Loading...' && saveAction.getHTMLContent(this.props.dispatch, false);
        }
        
        if((this.props?.buildProduct?.stickyheaderfooter && this.props?.appState.flowType !== 'MV' &&  this.props?.appState.flowType !== 'SUPP') || ((this.props?.appState?.flowType ==='MV'  && this.props?.buildProduct?.movesstickyheaderfooter && this.props?.lqState && this.props?.lqState?.runtimeKey && this.props?.lqState?.runtimeKey?.enableMovesStickyHeaderFooter === 'Y')) ){
            document.getElementById("fiosHeaderLq").style.position = "relative";
        }
        else if((this.props?.appState?.flowType ==='MV'  && !this.props?.buildProduct?.movesstickyheaderfooter && this.props?.lqState && this.props?.lqState?.runtimeKey && this.props?.lqState?.runtimeKey?.enableMovesStickyHeaderFooter === 'Y')){
            document.getElementById("fiosHeaderLq").style.position = "sticky";
        }
        
       // if(this.props.lqState && this.props.lqState.runtimeKey && this.props.runtimeKey.showHolidaytimer && this.props.lqState.runtimeKey.showHolidaytimer == "Y"){
         this.getTimer();
         this.interval=setInterval(this.getTimer,1000);
        window.updateBPPSignInValue =  this.updateBPPSignInValue;
        window.enableStickyFH =  this.enableStickyFH;
        window.enableStickyPB = this. enableStickyPB;
    }
   // }

   enableStickyFH = (enable = true) =>{
    this.props.dispatch({type:"ENABLE_STICKYHEADER_THROTTLE", value: enable});                        
    window.sessionStorage.setItem('stickyheaderfooter', 'fios_shf')
}

   enableStickyPB = (enable = true) =>{
    this.props.dispatch({type:"ENABLE_STICKYPROGRESSBAR_THROTTLE", value: enable});                        
    window.sessionStorage.setItem('stickyprogressbar', 'fios_spb')
}

    updateBPPSignInValue = (signInValue = false) => {
        this.props.dispatch({ type: "UPDATE_BPP_SIGNIN_VALUE", value: signInValue });
    }

    vednorTNClick = () => {
        window.location.href = "tel:1-" + this.props.appState.vendor.vendorTN;
    }

    savedCartClick = () => {
        action.closeModalWindow(this.props.modalWindow.modalId, this.props.dispatch);
        logoutSmartSave(this.props.dispatch, this.props.appState.mon_no);
    }

    hideSweetnerMsg = () => {
        let SweetnerMessage = {
            currentMsg: '',
            prevMsg: '',
            prevPromos: {
                INTERNET: [],
                TV: []
            },
            isDisplay: true
        }
        if (InHomeUtils.isNotNull(this.props.SweetnerMsg)) {
            SweetnerMessage.currentMsg = this.props.SweetnerMsg.currentMsg;
            SweetnerMessage.prevMsg = this.props.SweetnerMsg.prevMsg;
        }
        SweetnerMessage.isDisplay = false;
        SweetnerMsg(SweetnerMessage, this.props.dispatch);
    }


    hideSweetnerMsgMFRT = () => {
        let SweetnerMessageMFRT = {
            currentMsg: '',
            isDisplay: false
        }
        SweetnerMsgMFRT(SweetnerMessageMFRT, this.props.dispatch);
    }
    hideVZCCouponNotification = () => {
        let msgInfo = {
            currentMsg: '',
            isDisplay: false
        }
        updateVZCCouponNotificationMsg(msgInfo, false, this.props.dispatch);
    }


    
    checkIsHoa = () =>{
        return this.props.lqState && this.props.lqState.hoaFlowDetails && this.props.lqState.hoaFlowDetails.isHoaFlow;
    }


    //  localStorageValSet=(data)=>{
    //      window.sessionStorage.setItem("persist:root", data);
    //  }

    onClickSignInCTA = (e) => {
        if(e.target.id === 'signOutCTA'){
            updateSCTags("sign out header");
            this.props.dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: '' } });
            setTimeout(() => {
                InHomeUtils.clearMemory();
                localStorage?.clear();
                sessionStorage?.clear();
                this.props.dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: '' } });
                window.location.assign(this.getSigninURL(e.target.id));
            }, 3000);
        }
        else {
            updateSCTags("sign in header");
            window.location.assign(this.getSigninURL(e.target.id));
        }
    }

    handleSignInClose(e) {
        updateSCTags("close sign in modal");
        this.setState({showtooltip: false});
        e.preventDefault();
        e.stopPropagation();
        document.getElementById("signInCTA").focus()
    }

    handleKeyDownClose(e) {
        if (e.keyCode === 13 || e.keyCode === 32) {
            this.handleSignInClose(e);
            e.preventDefault();
        }
    }

    getSigninURL = (id) => {
        let APIContext = '';
        const qaEnv = window.location.host.split('.');
        const lowerEnv = qaEnv && qaEnv[0];
        const number = lowerEnv?.replace(/\D/g,'');
        if(id === 'signInCTA') {
            if (number > 0 || window.location.hostname === 'localhost') {
                const gotToUrl = `${window.location.origin}/inhome/change/fiosmnh`;
                APIContext = `https://securesit2.verizon.com/signin?userNameOnly=true&clientId=VZCOMBQ&goto=${gotToUrl}`;
            }
            else {
                APIContext = 'https://secure.verizon.com/signin?userNameOnly=true&clientId=VZCOMBQ&goto=https://www.verizon.com/inhome/change/fiosmnh';
            }
        }
        else if (number > 0 || window.location.hostname === 'localhost') {
                const gotToUrl = `${window.location.origin}/inhome/change/fiosmnh`;
                APIContext = `https://securesit2.verizon.com/signin/user/logout?next=${encodeURIComponent(
                    `https://securesit2.verizon.com/signin`,)}`;
        }
        else {
            APIContext = `https://secure.verizon.com/signin/user/logout?next=${encodeURIComponent(
                `https://secure.verizon.com/signin`,)}`;
        }
        return `${APIContext}`;
      };   
      
    closePPBanner = () => {
        modalAction.closeModalWindow("", this.props.dispatch, '',false);
        this.setState({ showPopularPlanBanner: false });
        // this.setState({signinClick: true});
           
    }

    verificationAPIListener = ()=>{
        let props = this.props;
        this.props.dispatch({type: 'MNH_IG_VERIFICATION_START', value: false });
        const callOver = buildProductaction.callVerificationAPI(props.buildProduct);
        Promise.all([callOver]).then(() => {
            modalAction.closeModalWindow(props.modalWindow.modalId, props.dispatch, '', false);
            props.dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: '' } });
            props.dispatch({
                type: 'LOADER_ACTIVE',
                value: { isLoaderActive: true, isLoaderText: "Fetching Details", isLoaderImg: "loader" }
            });
            setTimeout(() => {
                //props.dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: '' } });
                let dataPromise = buildProductaction.fetchDataMTM(props.dispatch, props.visitId, props.flowType);
                Promise.all([dataPromise]).then(()=> {
                    let mnhStatus = store && store.getState() && store.getState().buildProduct && store.getState().buildProduct.mnhStatus ? store.getState().buildProduct.mnhStatus : '';
                    if(props.buildProduct && props.buildProduct.internet && props.buildProduct.internet.selectedProduct){
                        props.dispatch({
                            type: 'LOADER_ACTIVE',
                            value: { isLoaderActive: true, isLoaderText: "Updating Cart", isLoaderImg: "loader" }
                        });
                        buildProductaction.updateRefreshIntent(props.visitId, props.dispatch, mnhStatus, props.buildProduct);        
                        actionn.updateCart(this.props.visitId, this.props.lqState, this.props.buildProduct?.internet?.selectedProduct, 'DATA', false, this.props.dispatch, 'DATA', this.props.firstBill, null, this.props.buildProduct?.contract?.contractType, this.props.buildProduct?.selectedCoreServices, false, false, null, null, this.props.buildProduct?.loadedEquipment, this.props.flowType);                              
                    }
                    else{
                        if(mnhStatus === 'Y'){
                            buildProductaction.getNameMnhDetailsBuildProduct(props.dispatch, props.buildProduct);
                            props.dispatch({ type: "SET_MNH_BANNER_STATUS", value: "UPDATE" });
                        }
                        else if(mnhStatus === 'maxAttempt'){
                            buildProductaction.mnhNotSuccessful(props.dispatch, props.buildProduct, true);
                        }
                    }
                });
            }, 10000);
        });
    }
    handleSigninClick = () => {
        this.setState({ showPopularPlanBanner: false });
        this.setState({signinClick: true})
        modalAction.openModalWindow("mnhSignIn", this.props.dispatch);
    }

    render() {
        const isMixandMatch=this.props.buildProduct?.mnFromApi && this.props.buildProduct?.isMNEnabled;
        let faqLayout = '';
        let faqMobLayout = '';
        let callmeLayout = '';
        let callMeMobLayout = '';
        let saveLayout = '';
        let saveMobLayout = '';
        let isEnableSave = false;
        let vzwLayout = '';
        let vzwHeader = '';
        let sweetnerMsg = '';
        let ecHeaderMsg = '';
        let espanolTag ='';
        let sweetnerMsgMFRT = '';
        let nsiPage = false;
        let streamlinePage = false;
        let pageName = '';
        let pathName = window.location.pathname;//this.props.history.location.pathname;
        let vendorFlow = false;
        let isTargetOrdering = false;        
        let vednorTN = "";
        let vendorVZLogo = false;
        let vzwNCHeaderLayout = '';
        let isResumedEmailMtn = false;
        let isNonSeamless = false;
        let isMoves = false;
        let vzcCouponNotificationMsg = '';
        let signInCookie = '';
        // console.log('****** monarch ', this.isMonarch);
        if(window.cookie){
            signInCookie  = window.cookie.split(";").filter(each => each.includes("islogin") || each.includes("loggedin=true"))[0]
        }
        let isLoggedIn = this.props?.appState?.flowType === 'MV' || (this.props?.appState?.flowType === 'NC' && signInCookie);
        //let mplang = '';var locStorage=''; let newStorage='';
        //mplang=MP.getCookie('MP_LANG');
        //let data='';
        //let visit_id = MP.getCookie('visit_id');
        //let visitor_id = MP.getCookie('visitor_id');
        const paddingTop = { paddingTop: "4px" };
        const displayNone = { display: 'none' };
        let navLinks = "";
        let cart = '';
        let moveLandPage = false;
        let isFlashOfferApplied = false;
        let showGNAV = false;
        let fiosReferral = window.sessionStorage.getItem('fiosReferralFlow');
        let isSummaryPage=false;
        let isLBO= pathName.includes('lbo') ? true:false;
        let isSupLboMvaFlow = pathName.indexOf('/change/supp/lbo')!= -1 && window?.innerWidth < 1080 ;
        let ribbonContent ='';
        let needHelp = this.props.appState && this.props.appState.vendor && this.props.appState.vendor.dig === "Y" ? false : true;
        const isECBuildProductsPage = pathName.indexOf('/change/buildproducts') > -1;
        const hideHeaderForSuspendServices = window.location && window.location.host == "www.verizon.com" && this.props.router.location?.pathname?.indexOf("suspendservices") > -1;  
        let gig = this.props.buildProduct.internet.speedCode.indexOf('941')>-1 ? true :false;
        const VerGC200 =(this.props.buildProduct.offersEligible) && this.props.buildProduct.offersEligible.indexOf(OfferTypes.VerizonGC200) > -1 ? true : false;
        let gc = this.props.buildProduct && this.props.buildProduct.offersEligible && this.props.buildProduct.offersEligible === "$200_VERIZON_GC_DISCOUNT" ? true : false;
        const isProgressBar = this.props?.appState.flowType !== 'MV' && this.props?.appState.flowType !== 'SUPP' &&  this.props?.appState?.flowType !== 'AF' && this.props?.buildProduct?.stickyProgressbar && ((this.props?.lqState && this.props?.lqState.runtimeKey && this.props?.lqState?.runtimeKey?.enableStickyProgressBar === 'Y'));
        const isMobile = (window.screen.width < 768) ? true : false;
        const isStickyFooterCartOpen = isMobile && this.props?.isCartOpen && ((this.props?.appState.flowType !== 'MV' &&  this.props?.appState.flowType !== 'SUPP' && this.props?.buildProduct?.stickyheaderfooter) || (this.props?.appState?.flowType ==='MV'  && this.props?.buildProduct?.movesstickyheaderfooter && this.props?.lqState && this.props?.lqState.runtimeKey && this.props?.lqState?.runtimeKey?.enableMovesStickyHeaderFooter === 'Y'));
    let mnhCustomerDetailPresent = this.props.runtimeKey && this.props.runtimeKey.mnhAuthCustomerRibbon && this.props.runtimeKey.mnhAuthCustomerRibbon === "Y" && this.props.internetProduct.mnhSignupIndicator && this.props.internetProduct.mnhSignupIndicator === "Y" && this.props.buildProduct.isMnHCustomerDetail ? true : false;
    let isStreamline = this?.props?.lqState?.streamlineLQ || false;
 
        //const isFlashOfferApplied = this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.BFHoliday2021 && this.props.lqState.runtimeKey.BFHoliday2021 === 'BF';
    let isBonusVerizon100GC = this.props.buildProduct && this.props.buildProduct.internet && this.props.buildProduct.internet.m2mPlans && this.props.buildProduct.internet.m2mPlans[0]?.specialOffers && this.props.buildProduct.internet.m2mPlans[0]?.specialOffers.filter(item => item.BsOfferAttrValue == "$100_VERIZON_GIFT_CARD_DISCOUNT_BONUS" && item.offerFor === "Data").length > 0 ? true : false;
        let isXboxseriesX = this.props.buildProduct && this.props.buildProduct.internet && this.props.buildProduct.internet.m2mPlans && this.props.buildProduct.internet.m2mPlans[0]?.specialOffers && this.props.buildProduct.internet.m2mPlans[0]?.specialOffers.filter(item => item.BsOfferAttrValue == "FIOS_XBOX_SERIES_X_CONSOLE" && item.offerFor === "Data").length > 0 ? true : false;
        let isFiveYearPrice =  this.props?.buildProduct && this.props?.buildProduct?.internet && this.props?.buildProduct?.internet?.m2mPlans && this.props?.lqState?.runtimeKey?.showRibbonBanner ==='Y' ? true : false;
        let isNCMVAppFlow = false;
        let showTimer =  this.props?.lqState?.runtimeKey?.showHolidaytimer&&this.props?.lqState?.runtimeKey?.showHolidaytimer ==="Y"?true:false;
        let aemKey = this.props.lqState && this.props.lqState.runtimeKey &&
                 this.props.lqState.runtimeKey.ribbonFilter && 
                 this.props.lqState.runtimeKey.ribbonFilter === "AEM" ? true : false;
        let isSpecialOfferNotPresent = this.props.buildProduct?.internet?.m2mPlans?.filter((plan) => plan.specialOffers?.length > 0).length === 0;
        let RCAEM =      this.props.buildProduct && this.props.buildProduct.plansPromoFragments &&
                  this.props.buildProduct.plansPromoFragments["~RibbonContent"] && 
                  this.props.buildProduct.plansPromoFragments["~RibbonContent"].promo ?
                 ReactHtmlParser(this.props.buildProduct.plansPromoFragments["~RibbonContent"].promo) :
                 this.props.lqState&&this.props.lqState.runtimeKey&&this.props.lqState.runtimeKey.EnableMHFiosSignIn&&this.props.lqState.runtimeKey.EnableMHFiosSignIn==="Y"?'Verizon mobile customers save more when they get Fios Internet.':'Pair your plans. Get rewarded today with Mobile + Home Rewards.' ;
                 // SWAT-186 BANNER 5 YEARS PRICE GUARANTEE isFiveYearPrice
                let RCAEM500 =  isFiveYearPrice && this.props.buildProduct && this.props.buildProduct.plansPromoFragments &&
                  this.props.buildProduct.plansPromoFragments["~RibbonContent500"] && 
                  this.props.buildProduct.plansPromoFragments["~RibbonContent500"].promo ?
                 ReactHtmlParser(this.props.buildProduct.plansPromoFragments["~RibbonContent500"].promo) :
                 this.props.lqState&&this.props.lqState.runtimeKey&&this.props.lqState.runtimeKey.EnableMHFiosSignIn&&this.props.lqState.runtimeKey.EnableMHFiosSignIn==="Y"?'Verizon mobile customers save more when they get Fios Internet.':'Pair your plans. Get rewarded today with Mobile + Home Rewards.' ;
              let aemrc = VerGC200 ? RCAEM : RCAEM500;
              let isNintendoSwitchPresent = false;
              isNintendoSwitchPresent = this.props.buildProduct?.internet?.m2mPlans?.[0]?.specialOffers?.findIndex((item)=> ["R4611"].includes(item?.USOCIOSC)) > -1 ? true :false;
              aemrc = !isNintendoSwitchPresent ? RCAEM : RCAEM500;
        if(InHomeUtils.isNotNull(this.props.signIn) && InHomeUtils.isNotNull(this.props.signIn.isNCMVAppFlow) && InHomeUtils.isNotNull(this.props.signIn.isMvAppFlow) && this.props.signIn.isNCMVAppFlow == false){
            isNCMVAppFlow = this.props.signIn.isMvAppFlow;
        }else
            isNCMVAppFlow = this.props.signIn.isNCMVAppFlow;

        showGNAV = !!(pathName.indexOf('/change/') > -1 && pathName.indexOf('/accountaccess') == -1 && pathName.indexOf('/signin') == -1 && pathName.indexOf('/change/connection') == -1);
       if(this.props.appState.flowType === 'AF'&&isLBO){
        showGNAV= false
       }
        if (this.props.appState.flowType === "SUPP" || hideHeaderForSuspendServices) {
            showGNAV = false;
        }
        if (InHomeUtils.isNotEmpty(this.props.lqState.lstRibbonContent)) {
                ribbonContent=this.props.lqState.lstRibbonContent;       
        }
        if (!showGNAV) {
            if (pathName === '/inhome/buildproducts' || pathName === '/inhome/buildproductsRskn' || pathName === '/inhome/popularPlans' || pathName === '/inhome/moves/buildproducts' || pathName === '/inhome/moves/buildproductsRskn' || (pathName.indexOf('/supp/buildproducts') > -1) || pathName === '/inhome/ordersummary' || pathName === '/inhome/moves/ordersummary') {
                pageName = 'buildproduct';
            } else if (pathName === '/inhome/checkout' || pathName === '/inhome/moves/checkout' || (pathName.indexOf('/supp/checkout') > -1)) {
                pageName = 'checkout';
                if (this.props.appState.flowType === "MV") {
                    moveLandPage = true;
                }
            } else if ((pathName.indexOf("streamlineordering") > -1 || pathName.indexOf("streamlinetvvoice") > -1)) {
                streamlinePage = true;
                pageName = 'streamline';
            } 
            else if (pathName.indexOf("nsinotification") > -1) {
                nsiPage = true;
                pageName = 'nsinotification';
            } else if (pathName === '/inhome/landing' || pathName === '/inhome/moves/landing' || pathName === '/inhome/moves/landingRskn' || pathName === '/inhome/moveLanding') {
                moveLandPage = true;
                pageName = 'movelanding';
            } 
            else if (this.props.appState.flowType === "MV" && (pathName === '/inhome/ordersummary' || pathName === '/inhome/moves/ordersummary')) {
                moveLandPage = false;
                pageName = 'ordersummary';
            }
            else if (this.props.appState.flowType === "MV" && (pathName === '/inhome/checkout' || pathName === '/inhome/moves/checkout')) {
                moveLandPage = true;
                pageName = 'checkout';
            }
            if (pathName === '/inhome/summary' || pathName === '/inhome/moves/summary' || (pathName.indexOf('/supp/summary') > -1)) {
                isSummaryPage=true;
            }
            //movechange
            if (this.props.moveState && this.props.moveState.moveLandingExp && this.props.moveState.moveLandingExp.movesEligibility === "NONSEAMLESS"){
                isNonSeamless = true;
            }

            if (this.props.appState && this.props.appState.flowType === "MV" && (pageName === "buildproduct" || pageName === "ordersummary") && !moveLandPage) {
                //alert('test')
                cart = <MovesCart isMonarch={this.isMonarch} />
            }
            else if (!moveLandPage) {
                cart = <Cart isMonarch={this.isMonarch} />
            }
            else if (pageName == 'checkout') {
                cart = <Cart isMonarch={this.isMonarch} />
            }
            //EnableSave only when FiosVoice is qualified. 
            let isFDVQualified = false;
            let isProductsAdded = (InHomeUtils.isNotNull(this.props.cartData) && this.props.cartData.length > 0 && InHomeUtils.isNotNull(this.props.cartData[0].serviceHeaders) && InHomeUtils.isNotNull(this.props.cartData[0].serviceHeaders.servicehead) && this.props.cartData[0].serviceHeaders.servicehead.length > 0) ? true : false;

            if (InHomeUtils.isNotNull(this.props.servicesQualified) && (InHomeUtils.isNotNull(this.props.servicesQualified.isVoiceQualified) || this.props?.lqState?.isRuralBroadBandAddress)) {
                isFDVQualified = this.props.servicesQualified.isVoiceQualified || this.props?.lqState?.isRuralBroadBandAddress;
            }
            if (isFDVQualified && isProductsAdded && this.props.appState.flowType !== "SUPP" && this.props.appState.flowType !== "MV") {
                isEnableSave = true;
            }

            
            if (isFDVQualified && isProductsAdded && this.props.appState.flowType !== "SUPP" && this.props.appState.flowType !== "MV" && (this.props.appState.flowType !== "MV" && this.props.appState.flowType !== "SUPP"  && this.props.buildProduct.stickyheaderfooter && !isStreamline) ) {
                isEnableSave = false;
            }

            if (this.props.save && this.props.save.issmartcartflow) {
                if (this.props.save.retrieveSmartCart !== null &&((InHomeUtils.isNotNull(this.props.save.retrieveSmartCart.email) && InHomeUtils.isNotEmpty(this.props.save.retrieveSmartCart.email))||(InHomeUtils.isNotNull(this.props.save.retrieveSmartCart.mtn) && InHomeUtils.isNotEmpty(this.props.save.retrieveSmartCart.mtn)))) {
                    isResumedEmailMtn = true;
                }
                else if(InHomeUtils.isNotNull(this.props.save.saveResponse) && ((InHomeUtils.isNotNull(this.props.save.saveResponse.email) && InHomeUtils.isNotEmpty(this.props.save.saveResponse.email))||(InHomeUtils.isNotNull(this.props.save.saveResponse.mtn) && InHomeUtils.isNotEmpty(this.props.save.saveResponse.mtn)))) {
                    isResumedEmailMtn = true;
                }
            }

            if (this.props.appState && this.props.appState.isTargetOrdering) {//need to comment this , if we get Target in vendorname
                isTargetOrdering = true;
                vendorFlow = true;
            }
            if (this.props.appState && this.props.appState.vendor && this.props.appState.vendor.vendorName !== "") {
                if (this.props.appState.isTargetOrdering) {
                    isTargetOrdering = true;
                }
                vendorFlow = true;
                if (this.props.appState.vendor.vendorTN !== "" && this.props.appState.vendor.vendorTN !== "null") {
                    vednorTN = this.props.appState.vendor.vendorTN.slice(0, 3) + "-" + this.props.appState.vendor.vendorTN.slice(3, 6) + "-" + this.props.appState.vendor.vendorTN.slice(6, 15);
                }
                if (InHomeUtils.isNotNull(this.props.appState.vendor) && InHomeUtils.isNotNull(this.props.appState.vendor.vendorName) && this.props.appState.vendor.vendorName.toLowerCase() !== "redventures" && this.props.appState.vendor.vendorName.toLowerCase() !== "wmcart" ) {
                    vendorVZLogo = true;
                }
            }
            // console.log('check modalplace',this.props.modalWindow.modalId,pathName)
            if (InHomeUtils.isNotNull(this.props.isFlashOfferApplied)) {
               isFlashOfferApplied = true;
            }
            if (this.props.modalWindow.modalId === ModalWindow.ids.faq) {
                faqLayout = <Faq closeModel={(e) => this.onCloseModal(e)} buildProductState={this.props.buildProduct} lqState={this.props.lqState} pageName={pageName} faqBuildProduct={this.props.faqBuildProduct} faqCheckout={this.props.faqCheckout} faqNsi={this.props.faqNsi} faqMoveLanding={this.props.faqMoveLanding} />;
            }
            else if (this.props.modalWindow.modalId === ModalWindow.ids.faq_Mob) {
                faqMobLayout = <Faq closeModel={(e) => this.onCloseModal(e)} buildProductState={this.props.buildProduct} lqState={this.props.lqState} pageName={pageName} faqBuildProduct={this.props.faqBuildProduct} faqCheckout={this.props.faqCheckout} faqNsi={this.props.faqNsi} faqMoveLanding={this.props.faqMoveLanding} />;
            }
            else if (this.props.modalWindow.modalId === ModalWindow.ids.callMeNow) {
                callmeLayout = <CallMe />;
            }
            else if (this.props.modalWindow.modalId === ModalWindow.ids.callMeNow_Mob) {
                callMeMobLayout = <CallMe />;
            }
            else if (this.props.modalWindow && this.props.modalWindow.modalId === ModalWindow.ids.save) {
                saveLayout = <Save closeModel={(e) => this.onCloseModal(e)} dispatch={this.props.dispatch} helpSave={this.props.save.helpSave} validateIpt={(e) => this.validateIpt(e)}
                    saveClick={this.onSaveClick} emailID={this.props.save.saveModalInput} mtn={this.props.save.mtn} monno={this.props.appState.mon_no} save_Invoked={this.props.save.save_Invoked} backInvoked={this.props.save.backInvoked}
                    creditDone={this.props.save.creditDone} saveDate={this.props.save.saveDate} validateInput={this.props.save.validateInput} emailError={this.props.save.emailError}
                    mtnError={this.props.save.mtnError} shopDeals={this.shopDeals} savedCartClick={this.savedCartClick} isResumedEmailMtn={isResumedEmailMtn} isFlashOfferApplied={isFlashOfferApplied} />;
            }
            else if (this.props.modalWindow && this.props.modalWindow.modalId === ModalWindow.ids.save_Mob) {
                saveMobLayout = <Save closeModel={(e) => this.onCloseModal(e)} dispatch={this.props.dispatch} helpSave={this.props.save.helpSave} validateIpt={(e) => this.validateIpt(e)}
                    saveClick={this.onSaveClick} emailID={this.props.save.saveModalInput} mtn={this.props.save.mtn} monno={this.props.appState.mon_no} save_Invoked={this.props.save.save_Invoked} backInvoked={this.props.save.backInvoked}
                    creditDone={this.props.save.creditDone} saveDate={this.props.save.saveDate} validateInput={this.props.save.validateInput} emailError={this.props.save.emailError}
                    mtnError={this.props.save.mtnError} shopDeals={this.shopDeals} savedCartClick={this.savedCartClick} isResumedEmailMtn={isResumedEmailMtn} isSmartCartResumeFlow={this.props.save.smartcartflow} isFlashOfferApplied={isFlashOfferApplied} />;
            }
            else if (this.props.modalWindow && this.props.modalWindow.modalId === ModalWindow.ids.footerLearn) {
                // if (InHomeUtils.isNotEmpty(this.props.lqState.vzwOffer) && this.props.lqState.vzwOffer.indexOf("VZWADVOFFERELIGIBLE:Y") > -1) {
                //     vzwLayout = <MHQualified lqState={this.props.lqState} closeModel={(e) => this.onCloseModal(e)} />
                // }
                // else {
                    //vzwLayout = <MHNQualified lqState={this.props.lqState} closeModel={(e) => this.onCloseModal(e)} />
                    vzwLayout = <MHNADDITIONALOFFER lqState={this.props.lqState} closeModel={(e) => this.onCloseModal(e)} buildProductState={this.props.buildProduct} />
                //}
            }
            else if (this.props.modalWindow && this.props.modalWindow.modalId === "MNHAUTH") {
                vzwLayout = <MHNQualified lqState={this.props.lqState} closeModel={(e) => this.onCloseModal(e)} />                    
            }
            else if(this.props.modalWindow && this.props.modalWindow.modalId === "signInCTA") {
            vzwLayout = <React.Fragment>
                                <ModalTitle></ModalTitle>
                                <ModalBody>
                                    <Iframe id="signinframe" url={this.getSigninURL(this.props.modalWindow.modalId)} width="100%" display="initial" position="relative" allowtransparency="true" scrolling="auto" frameBorder="0" allowFullScreen />
                                </ModalBody>
                            </React.Fragment>
            }
            // if (this.props.modalWindow.modalId.indexOf("mnhSignIn") > -1 ){
            //     console.log('DEBUG: SIGNIN LINK');
            //     vzwLayout = <MNHSIGNINOVERLAY onOpenModal={(e) => this.onOpenModal(e)} validateSignin={this.validateSignin} />
            // }
            //refer : https://onejira.verizon.com/browse/ITT-693191
            //if (this.props.appState.flowType === "SUPP" && (pathName.indexOf('/supp/buildproducts') > -1)) {
                // vzwHeader = <div>
                //     <div className="promo-ribbon prNotification" tabIndex="0">
                //     <div className="ribbon-container">
                //     <Body size="small" viewport={InHomeUtils.getdeviceType()} primitive="h2" color="white">
                //         Your order is pending. You can still make changes. Some changes may  affect your pricing and promotions. Click Cart to see more details.
                //     </Body>
                //     </div>
                //     </div>
                // </div>
            //}

            // else if (this.props.modalWindow.modalId.indexOf("mnhPushNotificationOverlay") > -1 && pathName === '/inhome/popularPlans'){
            //     console.log('DEBUG: verification check');
            //     let updatedMobileNumber = '';
            //     if(this.props.buildProduct.mnhMobileNumber){
            //         updatedMobileNumber = "*** *** "+ this.props.buildProduct.mnhMobileNumber.slice(-4);
            //     }
            //     <div>
            //     vzwLayout = <SignInMHVerification updatedMobileNumber={updatedMobileNumber} buildproduct = {this.props.buildProduct} closeModel={(e) => this.onCloseModal(e)} verificationAPIListener={this.verificationAPIListener} dispatch={this.props.dispatch} />

            //     {console.log('DEBUG: PP one', this.props)}
            //     <ModalOverlay className="vzicon small text-black middle" template={vzwLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
            //     {console.log('DEBUG: PP Final')}
            //     </div>
                
            // }
            

            else if ( pathName === '/inhome/popularPlans') {

                if (this.props.modalWindow.modalId.indexOf("mnhSignIn") > -1 ){
                    vzwLayout = <MNHSIGNINOVERLAY onOpenModal={(e) => this.onOpenModal(e)} validateSignin={this.validateSignin} dispatch={this.props.dispatch} />
                }

                if (this.props?.modalWindow?.modalId?.indexOf("mnhPushNotificationOverlay") > -1 ){
                        let updatedMobileNumber = '';
                        if(this.props?.buildProduct?.mnhMobileNumber){
                            updatedMobileNumber = "*** *** "+ this.props?.buildProduct?.mnhMobileNumber?.slice(-4);
                        }
                    vzwLayout = <SignInMHVerification updatedMobileNumber={updatedMobileNumber} buildproduct = {this.props?.buildProduct} lqState = {this.props.lqState} closeModel={(e) => this.onCloseModal(e)} verificationAPIListener={this.verificationAPIListener} dispatch={this.props.dispatch} />}
                // if(this.state.signinClick ){
                //     console.log('DEBUG: modalId', this.props.modalWindow.modalId);
                //     vzwLayout = <MNHSIGNINOVERLAY closeModel={(e) => this.onCloseModal(e)} onOpenModal={(e) => this.onOpenModal(e)} validateSignin={this.validateSignin}/>
                
                // }
                vzwHeader = <div>
                <div style={{display:isMobile && window.location.pathname.includes('popularPlans') && (this.props.appState.flowType === 'MV' || this.props.appState.flowType === 'NC') ? 'block' : ''}} 
                className={this.isMonarch ? 'promo-ribbon-monarch' : 'promo-ribbon'} tabIndex="0"><div className="ribbon-container">
                <Body size="small" viewport={InHomeUtils.getdeviceType()} primitive="h2" color={this.isMonarch ? '#000000' : 'white'}>
                 <div>       
                <div >
                {(isMixandMatch&&this.props?.lqState?.runtimeKey?.showRibbonBanner && isFiveYearPrice) ?
                <span className="margin-bottom-zero mobileviewbanner">{aemrc}
                {this.props?.lqState?.runtimeKey?.ribbonFilter==="AEM"?<span></span>:<Tooltip className="promo-ribbo pointer" title="" size="small" ariaLabel="More Information about Limited time offer tooltip" inverted={false}>
                    {'Your monthly price for service is guaranteed to stay the same for 5 years. No annual contract required.'}
                </Tooltip>}</span>:<p className={this.isMonarch ? 'margin-bottom-zero monarch-banner' : "margin-bottom-zero"}>Verizon mobile customers save more when they get Fios.
                    <span onKeyDown={(e) => this.handleKeyDown(e)} onClick={() => {
                        {this.setState({ showPopularPlanBanner: true })}
                    } 
                    }id='FOOTER_LEARN' className="pointer" style={{position:"relative"}}>&nbsp;&#124;&nbsp;<TextLink type="standAlone" tabIndex="0" ref={this.linkRef} role="button" id="detailsRef" ariaLabel="Pair your plans. Get rewarded today with Mobile + Home Rewards opens a modal"><span className="mnhRibbonBanner">Details</span></TextLink> 
                    </span>
                   
                    {/* {this.state.showPopularPlanBanner &&  */}
                   
                    {this.state.showPopularPlanBanner && <VZMobileBanner closeBanner={this.closePPBanner} signinClicked= {this.handleSigninClick} buildProduct={this.props.buildProduct} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}/> }

                   <ModalOverlay className="vzicon small text-black middle" template={vzwLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
                </p>}
                {showTimer&&aemKey && !isSpecialOfferNotPresent &&isFiveYearPrice && <span> Offer ends in</span>}
                                {!isSpecialOfferNotPresent && this.props.runtimeKey && this.props.runtimeKey.showHolidaytimer && this.props.runtimeKey.showHolidaytimer === "Y" && isFiveYearPrice&&
                                       <b style={{color:'#EE0000'}}> 
                                       &nbsp;{ this.state.day >1?`${this.state.day} days`:`${this.state.day} day`} | { this.state.hour >1?`${this.state.hour} hrs`:`${this.state.hour} hr`} | { this.state.min >1?`${this.state.min} mins`:`${this.state.min} min`} | {this.state.sec>1?`${this.state.sec} secs`:`${this.state.sec} sec`}</b>}
                </div>
                </div>
                </Body>
        </div></div>
            </div>
        }         
            else if ((this.props?.lqState?.couponFlowType !== "Employee") && (pathName === '/inhome/buildproducts' || pathName === '/inhome/buildproductsRskn' || pathName === '/inhome/moves/buildproducts' || pathName === '/inhome/moves/buildproductsRskn'|| pathName==='/inhome/streamlineordering' || pathName==='/inhome/streamlinetvvoice')  && InHomeUtils.isNotNull(this.props.internetProduct)
                && InHomeUtils.isNotEmpty(this.props.internetProduct.speedCode) && (this.props.internetProduct.speedCode.indexOf('941') > -1 || this.props.internetProduct.speedCode.indexOf('940') > -1 || this.props.internetProduct.speedCode.indexOf('947') > -1) ) {
                    
                let jsonKey = this.props.lqState && this.props.lqState.runtimeKey 
                && this.props.lqState.runtimeKey.ribbonFilter && 
                this.props.lqState.runtimeKey.ribbonFilter === "JSON" ? true : false;
                let RCjson = this.props.lqState && this.props.lqState.lstRibbonContent && 
                this.props.lqState.lstRibbonContent["promo-ribbons"] ?
                gig ?
                this.props.lqState.lstRibbonContent["promo-ribbons"].PROACTIVE_LC_COUNTDOWN ?
                 ReactHtmlParser( this.props.lqState.lstRibbonContent["promo-ribbons"].PROACTIVE_LC_COUNTDOWN.ribbon_title+". " + this.props.lqState.lstRibbonContent["promo-ribbons"].PROACTIVE_LC_COUNTDOWN.ribbon_desc ) :                                  
                 this.props.lqState&&this.props.lqState.runtimeKey&&this.props.lqState.runtimeKey.EnableMHFiosSignIn&&this.props.lqState.runtimeKey.EnableMHFiosSignIn==="Y"?'Verizon mobile customers save more when they get Fios Internet.':'Pair your plans. Get rewarded today with Mobile + Home Rewards.':
                this.props.lqState.lstRibbonContent["promo-ribbons"].PROACTIVE_LC_COUNTDOWN_500 ? 
                ReactHtmlParser( this.props.lqState.lstRibbonContent["promo-ribbons"].PROACTIVE_LC_COUNTDOWN_500.ribbon_title+". " + this.props.lqState.lstRibbonContent["promo-ribbons"].PROACTIVE_LC_COUNTDOWN_500.ribbon_desc) 
                : this.props.lqState&&this.props.lqState.runtimeKey&&this.props.lqState.runtimeKey.EnableMHFiosSignIn&&this.props.lqState.runtimeKey.EnableMHFiosSignIn==="Y"?'Verizon mobile customers save more when they get Fios Internet.':'Pair your plans. Get rewarded today with Mobile + Home Rewards.':
                this.props.lqState&&this.props.lqState.runtimeKey&&this.props.lqState.runtimeKey.EnableMHFiosSignIn&&this.props.lqState.runtimeKey.EnableMHFiosSignIn==="Y"?'Verizon mobile customers save more when they get Fios Internet.':'Pair your plans. Get rewarded today with Mobile + Home Rewards.';
                 
              // ACT112-921 Added default ribbon as MHsignIn
              let deafultRibbon = this.props.lqState&&this.props.lqState.runtimeKey&&this.props.lqState.runtimeKey.EnableMHFiosSignIn&&this.props.lqState.runtimeKey.EnableMHFiosSignIn==="Y"? ReactHtmlParser(this.props?.buildProduct?.plansPromoFragments["DefaultBanner~DefaultBanner"]?.promo) : '' 
              // ITT-686319 :: Manoj :: fix setting default banner message for Baltimore/Pittsburgh DMA based n special offer present.
              // hiding countDown banner for student with discountEligible
              let mfrtType = this.props.lqState.mfrtType;
              let studentBannerCSS = true;
              if (InHomeUtils.isNotNull(this.props.isFCPflow) && this.props.isFCPflow && InHomeUtils.isNotNull(this.props.SweetnerMsgMFRT) && InHomeUtils.isNotNull(this.props.SweetnerMsgMFRT.discountEligible) && this.props.SweetnerMsgMFRT.discountEligible && mfrtType == "student") {               
                studentBannerCSS = false;
              }
            
                vzwHeader = <div id='verizonFiosHeaderId' style={(this.props.buildProduct.isMNEnabled || studentBannerCSS) ? {backgroundColor: this.isMonarch ? '#F3EDE0' : "#333333"} : {display: "none"}}>
                    {<div className={!this.isReskin ? `${this.isMonarch ? 'promo-ribbon-monarch prNotification_monarch' : 'promo-ribbon  prNotification'}` : `promo-ribbon prNotificationReskin ${this.isMonarch ? 'promo-ribbon-monarch prNotification_monarch' : 'prNotification'} ${isStickyFooterCartOpen ? "stickyHeaderOverlayBackground" : "" }`}>
                        <div className={'ribbon-container'}>
                        {/* { this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.ribbonFilter && this.props.lqState.runtimeKey.ribbonFilter != "N" && <img alt="Count down timer" src={require('./../../assets/ak-cached/24h/img/last-chance-timer-icon-white.png').default} style={{paddingRight : "1em"}} width="30px" /> }  */}
                        { this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.ribbonFilter && this.props.lqState.runtimeKey.ribbonFilter != "N" } 
                            <Body size="small" viewport={InHomeUtils.getdeviceType()} color={this.isMonarch ? '#000000': 'white'}>
                                {/* <span className="timerImage"></span> */}
                                { /*this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.ribbonFilter && this.props.lqState.runtimeKey.ribbonFilter === "JSON" && 
                                this.props.lqState && this.props.lqState.lstRibbonContent && this.props.lqState.lstRibbonContent["promo-ribbons"] ?
                                 gig ?
                                this.props.lqState.lstRibbonContent["promo-ribbons"].PROACTIVE_LC_COUNTDOWN ? 
                                 ReactHtmlParser( this.props.lqState.lstRibbonContent["promo-ribbons"].PROACTIVE_LC_COUNTDOWN.ribbon_title+". " + this.props.lqState.lstRibbonContent["promo-ribbons"].PROACTIVE_LC_COUNTDOWN.ribbon_desc ) :                                  
                                 'Pair your plans. Get rewarded today with Mobile + Home Rewards.':
                                 this.props.lqState.lstRibbonContent["promo-ribbons"].PROACTIVE_LC_COUNTDOWN_500 ? 
                                 ReactHtmlParser( this.props.lqState.lstRibbonContent["promo-ribbons"].PROACTIVE_LC_COUNTDOWN_500.ribbon_title+". " + this.props.lqState.lstRibbonContent["promo-ribbons"].PROACTIVE_LC_COUNTDOWN_500.ribbon_desc) :
                                 this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.ribbonFilter && this.props.lqState.runtimeKey.ribbonFilter === "AEM" &&
                                  this.props.buildProduct && this.props.buildProduct.plansPromoFragments && this.props.buildProduct.plansPromoFragments["~RibbonContent"] && this.props.buildProduct.plansPromoFragments["~RibbonContent"].promo ?
                                   ReactHtmlParser(this.props.buildProduct.plansPromoFragments["~RibbonContent"].promo) :
                                `Pair your plans. Get rewarded today with Mobile + Home Rewards.` :
                                 'Pair your plans. Get rewarded today with Mobile + Home Rewards.' }
                                { this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.ribbonFilter && this.props.lqState.runtimeKey.ribbonFilter === "N" && <span onKeyDown={(e) => this.handleKeyDown(e)} onClick={(e) => this.onOpenModal(e)} id='FOOTER_LEARN' className="promo-ribbo pointer">
                                     <span tabIndex="0" title="icon" role="button" aria-label="Pair your plans. Get rewarded today with Mobile + Home Rewards opens a modal" className="verizon-icons Icon--info"></span>
                                </span> */}
                                <div >
                                    <div className = "bannerheight">
                                    {/* removed else part as part of act112-921 content will only display from AEM */}
                                { jsonKey ? RCjson : (aemKey && !isSpecialOfferNotPresent && isFiveYearPrice) ? <span className="margin-bottom-zero mobileviewbanner"> {aemrc} 
                                {this.props.lqState?.runtimeKey?.ribbonFilter==="AEM"?<span></span>:<Tooltip className="tooltip-icon1 pointer" title="" size="small" ariaLabel="More Information about Limited time offer tooltip" inverted={false}>
                                    <span  >{'Your monthly price for service is guaranteed to stay the same for 5 years. No annual contract required.'}  </span>
                              </Tooltip>}</span> : <p className="margin-bottom-zero mnhRibbonBanner" > {deafultRibbon}
                                        <span onKeyDown={(e) => this.handleKeyDown(e)} onClick={() => {this.setState({ showPopularPlanBanner: true }); updateSCTags("Mobile + Home details") }} id='FOOTER_LEARN' className="pointer" style={{position:"relative"}}>
                                            {/* <span tabIndex="0" ref={this.linkRef} id="detailsRef" role="button" style={{paddingLeft:"5px", textDecoration:"underline"}} aria-label="Pair your plans. Get rewarded today with Mobile + Home Rewards opens a modal">Details</span> */}
                                            &nbsp;&#124;&nbsp;<TextLink type="standAlone" tabIndex="0" ref={this.linkRef} role="button" id="detailsRef" ariaLabel="Pair your plans. Get rewarded today with Mobile + Home Rewards opens a modal"><span className="mnhRibbonBanner">Details</span></TextLink> 
                                            {/* <span tabIndex="0" title={this.props.lqState&&this.props.lqState.runtimeKey&&this.props.lqState.runtimeKey.EnableMHFiosSignIn&&this.props.lqState.runtimeKey.EnableMHFiosSignIn==="Y" && this.props.lqState.isFCPflow ? '' : 'icon'} role="button" aria-label="Pair your plans. Get rewarded today with Mobile + Home Rewards opens a modal" className="verizon-icons Icon--info"></span> */}
                                        </span>
                                       
                                        { (this.state.showPopularPlanBanner || this.props?.modalWindow?.modalId==='mnhFromRibbonBanner') && <VZMobileBanner closeBanner={this.closePPBanner} signinClicked= {this.handleSigninClick} buildProduct={this.props.buildProduct} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}/> }
                                    </p> }
                                {/* this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.ribbonFilter && this.props.lqState.runtimeKey.ribbonFilter === "N" && !isFiveYearPrice && !isSpecialOfferNotPresent && <span onKeyDown={(e) => this.handleKeyDown(e)} onClick={(e) => this.onOpenModal(e)} id='FOOTER_LEARN' className="promo-ribbo pointer">
                                <span tabIndex="0" title={this.props.lqState&&this.props.lqState.runtimeKey&&this.props.lqState.runtimeKey.EnableMHFiosSignIn&&this.props.lqState.runtimeKey.EnableMHFiosSignIn==="Y" && this.props.lqState.isFCPflow ? '' : 'icon'} role="button" aria-label="Pair your plans. Get rewarded today with Mobile + Home Rewards opens a modal" className="verizon-icons Icon--info"></span>
                     */}
                                {/* {!mnhCustomerDetailPresent && <Tooltip
                                            title=""
                                            size="small"
                                            inverted={false}>
                                            <span style={{fontWeight : "100", lineHeight: "14px"}}>{this.props.lqState&&this.props.lqState.runtimeKey&&this.props.lqState.runtimeKey.EnableMHFiosSignIn&&this.props.lqState.runtimeKey.EnableMHFiosSignIn==="Y" && this.props.lqState.isFCPflow ? 'Your monthly price for service is guaranteed to stay the same for 10 years. No annual contract required.' : 'icon'}</span>
                                        </Tooltip>} */}
                                {/* </span> } */}
                                { showTimer && aemKey && !isSpecialOfferNotPresent &&isFiveYearPrice && <span> Offer ends in</span>}
                                {!isSpecialOfferNotPresent && this.props.runtimeKey && this.props.runtimeKey.showHolidaytimer && this.props.runtimeKey.showHolidaytimer === "Y" && isFiveYearPrice&&
                                       <b style={{color:'#EE0000'}}> 
                                       &nbsp;{ this.state.day >1?`${this.state.day} days`:`${this.state.day} day`} | { this.state.hour >1?`${this.state.hour} hrs`:`${this.state.hour} hr`} | { this.state.min >1?`${this.state.min} mins`:`${this.state.min} min`} | {this.state.sec>1?`${this.state.sec} secs`:`${this.state.sec} sec`}
                                        {/* <div className="counter-part">  
                                    <div className="count-value">{this.state.day}</div>
                                    <div className="count-name">DAYS</div> 
                                </div>
                                <div className="counter-part">  
                                    <div className="count-value">{this.state.hour}</div>
                                    <div className="count-name">HOURS</div> 
                                </div>
                                <div className="counter-part">  
                                    <div className="count-value">{this.state.min}</div>
                                    <div className="count-name">MINS</div> 
                                </div>
                                <div className="counter-part">  
                                    <div className="count-value">{this.state.sec}</div>
                                    <div className="count-name">SECS</div> 
                                    </div> */}
                                   
                                        </b> } 
                                    </div>
                                </div>
                            </Body>
                        </div>
                        {/* {this.props.runtimeKey && this.props.runtimeKey.showHolidaytimer && this.props.runtimeKey.showHolidaytimer === "Y" &&
                        <div className="countdown-timer-container">  
                                                  
                             <div>                                   
                                <div className="counter-part">  
                                    <div className="count-value">{this.state.day}</div>
                                    <div className="count-name">DAYS</div> 
                                </div>
                                <div className="counter-part">  
                                    <div className="count-value">{this.state.hour}</div>
                                    <div className="count-name">HOURS</div> 
                                </div>
                                <div className="counter-part">  
                                    <div className="count-value">{this.state.min}</div>
                                    <div className="count-name">MINS</div> 
                                </div>
                                <div className="counter-part">  
                                    <div className="count-value">{this.state.sec}</div>
                                    <div className="count-name">SECS</div> 
                                </div>
                            </div>                            
                        </div> } */}
                    </div>}
                    {/* Commenting below Code as per ACT112-802 story Figma requirement  */}
                    
                    {/* {mnhCustomerDetailPresent && <div className={`promo-ribbon prNotificationReskin ${this.isMonarch ? 'promo-ribbon-monarch prNotification_monarch' : 'prNotification'}`}>
                        <div className="ribbon-container ">
                            <div>{"Congratulations, "}<b>{this.props.buildProduct.isMnHCustomerDetail}</b>{"! You are qualified for our exclusive Mobile + Home Discount."}
                            </div>
                            <span onKeyDown={(e) => this.handleKeyDown(e)} 
                             onClick={(e) => {
                                {this.setState({ showPopularPlanBanner: true })}
                            }}
                            id='FOOTER_LEARN' className="promo-ribbo pointer">
                            <span tabIndex="0" title={''} role="button" className="verizon-icons Icon--info"></span>
                            </span>
                        </div>
                        {this.state.showPopularPlanBanner && <VZMobileBanner closeBanner={this.closePPBanner} signinClicked= {this.handleSigninClick} buildProduct={this.props.buildProduct} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}/> }

                    </div>} */}
                    <>
                    <ModalOverlay className="vzicon small text-black middle" template={vzwLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
                    </>

                </div>;
            }

            const isStreamlineOrderingMnH = window.location.pathname.includes("/streamlineordering") && (this.props?.buildProduct?.mnhStatus === "Y" || this.props?.buildProduct?.internet?.mnhSignupIndicator === "Y");
            // if (this.props.lqState.isFCPflow && window.location.href.indexOf("buildproductsRskn") == -1) {
            if (this.props.lqState.isFCPflow && window.location.href.indexOf("buildproducts") == -1  && window.location.href.indexOf("ordersummary") == -1  && window.location.href.indexOf("checkout") == -1 && !isStreamlineOrderingMnH ) {
                sweetnerMsg = <div className={InHomeUtils.isNotNull(this.props?.SweetnerMsg) && InHomeUtils.isNotEmpty(this.props?.SweetnerMsg?.currentMsg) && this.props?.SweetnerMsg?.isDisplay ? "" : "hide"}>
                    <div className="fcp-ribbon" tabIndex="0" role="alert">
                        <div className="fcp-inner">
                            <span title="close" className="verizon-icons Icon--close" onClick={this.hideSweetnerMsg}></span>
                            {ReactHtmlParser(this.props?.SweetnerMsg?.currentMsg)}
                        </div>
                    </div>
                </div>;
            }
            if (pathName === '/inhome/twsdiscount' && this.props.MFRTEligible && InHomeUtils.isNotNull(this.props.SweetnerMsgMFRT)) {
                const rootClassName = "fcp-ribbon " + this.props.SweetnerMsgMFRT.bgColor;
                sweetnerMsgMFRT = <div className={InHomeUtils.isNotNull(this.props.SweetnerMsgMFRT) && InHomeUtils.isNotEmpty(this.props.SweetnerMsgMFRT.currentMsg) && this.props.SweetnerMsgMFRT.isDisplay ? "" : "hide"}>
                    <div className={rootClassName} tabIndex="0" role="alert">
                        <div className="fcp-inner">
                            <span title="close" className="verizon-icons Icon--close" onClick={this.hideSweetnerMsgMFRT}></span>
                            {ReactHtmlParser(this.props.SweetnerMsgMFRT.currentMsg)}
                        </div>
                    </div>
                </div>;
            }
            if (InHomeUtils.isNotNull(this.props.vzcCouponInfo) && this.props.vzcCouponInfo.vzcValidationSuccess) {
                const rootClassName = "fcp-ribbon ";
                vzcCouponNotificationMsg = <div className={InHomeUtils.isNotNull(this.props.vzcCouponInfo) && InHomeUtils.isNotEmpty(this.props.vzcCouponInfo.currentMsg) && this.props.vzcCouponInfo.isDisplay ? "" : "hide"}>
                    <div className={rootClassName} tabIndex="0" role="alert">
                        <div className="fcp-inner">
                            <span title="close" className="verizon-icons Icon--close" onClick={this.hideVZCCouponNotification} ></span>
                            {ReactHtmlParser(this.props.vzcCouponInfo.currentMsg)}
                        </div>
                    </div>
                </div>;
            }
            if (this.props.appState.flowType === "MV" && window.location.pathname.indexOf('moves/buildproducts') > -1) {
                isMoves = true
            }

            if ((pathName === '/inhome/buildproducts' || pathName === '/inhome/buildproductsRskn' || pathName === '/inhome/streamlineordering' || pathName === '/inhome/streamlinetvvoice' || pathName === '/inhome/popularPlans' || pathName=== '/inhome/ordersummary' || pathName=== '/inhome/ordersummaryRskn' || pathName=== '/inhome/moves/ordersummary' || pathName === '/inhome/moves/buildproducts' || pathName === '/inhome/moves/buildproductsRskn' || pathName === '/inhome/change/supp/buildproducts' || pathName === '/inhome/checkout' || pathName === '/inhome/moves/checkout' || pathName === '/inhome/change/supp/checkout') || nsiPage || moveLandPage) {
                const toolTipText = "to your mobile account to find out if you're eligible for home internet discounts.";
                navLinks = <div className="topnav_userlinks ">
                    {this.props.buildProduct.bppPageSignIn && (this.props.appState.flowType === 'MV' || this.props.appState.flowType === 'NC') &&
                    <>
                        <div style={window.screen.width > 480 ? {marginTop: '10px', marginRight: '24px'} : {marginTop: '5px', marginRight: isEnableSave ? 0 : '24px', position: isEnableSave ? 'absolute' : 'relative', width: 'auto'}} className={`left topnav_userlink-options text-center planDetailsButtonTextRskn ${window.screen.width > 500 ? " show-for-small-up" : " hide-for-small-up padding-top-small"}` }>
                            <div className="small-clear small-border-none">
                                <div className={(pageName == 'movelanding' && isNonSeamless) ? "hide" : (this.props.buildProduct.isACPFlag ) ? 'padding-right-small' : "faqCls left small-p-auto"} data-equalwidth="Nav" >
                                    <div className={`alt text-center ${this.isMonarch ? 'text-black' : 'text-white'} pointer`} style={{position: 'relative'}}>
                                        <span aria-label={`Sign in ${this.state?.showtooltip && this.props?.buildProduct?.bppPageSignIn === 'signInWithTooltip' ? toolTipText : ''}`} role="button" tabIndex="0" id={isLoggedIn ? 'signOutCTA' : 'signInCTA'} onClick={e => this.onClickSignInCTA(e)} onKeyDown={(e) => this.handleSignInKeyDown(e)} >{ isLoggedIn ? "Sign out" : "Sign in"}</span>
                                        {this.state?.showtooltip && this.props.buildProduct.bppPageSignIn && this.props.buildProduct.bppPageSignIn === 'signInWithTooltip' && !isLoggedIn && (<>
                                            <StyledTooltipIcon></StyledTooltipIcon>
                                            <StyledTooltipDiv id='signInToolTip'>
                                            <Body size="large"  primitive="p"  viewport="Regular" surface="Light" color="#000000">
                                                <b> Sign in </b> 
                                                {toolTipText} 
                                            </Body>
                                            <span className='signIncloseIcon'>
                                                <a
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.handleSignInClose(e)
                                                }}
                                                onKeyDown={(e) => {
                                                    e.stopPropagation();
                                                    this.handleKeyDownClose(e)
                                                }}
                                                role="button"
                                                aria-label="Close Sign in pop over"
                                                className= "bold margin-left-micro  vzicon top-icon-close " tabIndex="0">
                                                    <CloseIcon size="medium" color="#000000"/>
                                                </a>
                                            </span>
                                            </StyledTooltipDiv>
                                        </>)}
                                        <span className="sr-only"></span>
                                    </div>
                                    <ModalOverlay className="vzicon small text-white middle" template={vzwLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
                                </div>
                            </div>
                        </div>
                    </>}
                    <div className="left show-for-small-up topnav_userlink-options text-center">
                        <div className="small-clear small-border-none">
                            <div className={moveLandPage ? "hide" : nsiPage ? "hide" : "show-for-medium-up padding-right-large"} style={{ paddingTop }}>
                                <div className="alt bold text-center"><span id="aimsChatIcon"></span></div>
                            </div>

                            <div className={(pageName == 'movelanding' && isNonSeamless) ? "hide" : (this.props.buildProduct.isACPFlag ) ? 'padding-right-small' : "faqCls left small-p-auto"} data-equalwidth="Nav" >
                                <div role="button" tabIndex="0" id='FAQ' onClick={(e) => this.onOpenModal(e)} onKeyDown={(e) => this.handleKeyDown(e)} className={`alt text-center ${this.isMonarch ? 'text-black' : 'text-white'} pointer`}>
                                    {!this.isReskin && <><span id='FAQ'>FAQs</span>
                                    <span className={`verizon-icons small Icon--support-drawer ${this.isMonarch ? 'text-black' : 'text-white'} middle`} aria-hidden="true" id='FAQ'></span></>}
                                    { this.isReskin && <StyledFAQ><span className={`verizon-icons small Icon--support-drawer ${this.isMonarch ? 'text-black' : 'text-white'} middle`} aria-hidden="true" id='FAQ'></span><span id='FAQ' className={`${this.isReskin? 'FAQ' : ''}`}><span className="sr-only">Open modal with</span>FAQs</span></StyledFAQ>}
                                    <span className="sr-only"></span>
                                </div>
                                <ModalOverlay className="vzicon small text-white middle" template={faqLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
                            </div>

                            <div className={moveLandPage ? "hide" : nsiPage ? "hide" : "chatDrop left small-padding-vert-tiny left small-p-auto hide"} data-equalwidth="Nav" aria-hidden="true">
                                <div className={`padding-left-tiny text-center ${this.isMonarch ? 'text-black' : 'text-white'} pointer hide`}>
                                    <span onClick={(e) => this.onOpenModal(e)} id='CALLME'>Call me</span>
                                    <span className={`verizon-icons small Icon--phone ${this.isMonarch ? 'text-black' : 'text-white'} middle`} aria-hidden="true"></span>
                                </div>
                                <ModalOverlay className={`verizon-icons small Icon--phone ${this.isMonarch ? 'text-black' : 'text-white'} middle`} template={callmeLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
                            </div>

                            <div className={moveLandPage ? "hide" : nsiPage ? "hide" : "TFNMobile left small-padding-vert-tiny left small-p-auto hide"} id="accordion-TFNMobile" style={displayNone} data-equalwidth="Nav">
                                <div id="scbResTFN" className="hide">
                                    <div>
                                        <span className={`verizon-icons small Icon--phone ${this.isMonarch ? 'text-black' : 'text-white'} middle`} aria-hidden="true"></span>
                                        <p className="clear margin-bottom-zero">Call</p>
                                        <p id="scbspantfn" style={displayNone}>888-791-1899</p>
                                    </div>
                                </div>
                            </div>
                            <div className={(nsiPage || !isEnableSave || this.props.buildProduct.isACPFlag) ? "hide" : "saveMobile more small-padding-vert-tiny left small-p-auto"}>
                                <div className={isFDVQualified ? isEnableSave ? "alt pointer  inline-block" : "alt pointer savecartcta dropSave inline-block disabled" : "hide"} onClick={(e) => this.onOpenModal(e)} onKeyDown={(e) => this.handleKeyDown(e)} id='SAVE' tabIndex={isEnableSave ? "0" : "-1"} role="button">
                                {!this.isReskin && <> <span id='SAVE' className={`save-cart-text text-center ${this.isMonarch ? 'text-black' : 'text-white'}`}>
                                        <span className="sr-only">Open </span>Save<span className="sr-only">modal</span><span className={`verizon-icons small Icon--save ${this.isMonarch ? 'text-black' : 'text-white'} middle`} id='SAVE'></span></span>
                                    </>}
                                    { this.isReskin  && <StyledFAQ><span className={`verizon-icons small Icon--save ${this.isMonarch ? 'text-black' : 'text-white'} middle`} onClick={(e) => this.onOpenModal(e)} onKeyDown={(e) => this.handleKeyDown(e)} id='SAVE'></span><span onClick={(e) => this.onOpenModal(e)} onKeyDown={(e) => this.handleKeyDown(e)} id='SAVE' className={`save-cart-text text-center ${this.isMonarch ? 'text-black' : 'text-white'} Save`}>
                                        <span className="sr-only">Open </span>Save<span className="sr-only">modal</span></span></StyledFAQ>}
                                </div>
                                 <ModalOverlay className="verizon-icons small Icon--save text-white middle" template={saveLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
                            </div>
                        </div>
                    </div>
                    <div className={nsiPage  || streamlinePage? "hide" : "more left inline-block tiny-padding-left-zero"} data-equalwidth="Nav">
                        {(((this.props?.appState.flowType !== 'MV' && this.props?.appState.flowType !== 'SUPP' && this.props?.buildProduct?.stickyheaderfooter)) || streamlinePage) ? '' : cart}
                    </div>
                    <div className="left topnav_userlink-options text-center hide-for-small-up">
                        {!(isNCMVAppFlow||window.location.search.includes("mvapp")) &&
                        <a className="padding-top-small bold text-white block" tabIndex="0" id="optionsButton" data-reveal-trigger="mobile_options" onClick={this.mobileHelp} role="button" aria-label="menu opens a modal">
                            <span className="header_border-options"></span>
                            <span className={this.isMonarch ?"verizon-icons Icon--menu small text-black":"verizon-icons Icon--menu small text-white"}></span> 
                        </a>
                        }
                        
                        <ul className={this.props.appState.mobileHelpReveal ? "small-clear tiny-border-top small-border-none topnav_userlink-options-mobile" : "small-clear tiny-border-top small-border-none topnav_userlink-options-mobile hide"} id="navSlidedown" data-reveal-content="mobile_options" data-reveal-speed="100">
                            <li className="faqCls show-for-tiny-only left inline-block tiny-p-20 small-p-auto" id="accordion-faqmobile" data-equalwidth="Nav">
                                <div id="faq" role="button" onKeyDown={(e) => this.handleKeyDown(e)} onClick={(e) => this.onOpenModal(e)} className={!this.isReskin ? "text-center pointer" : "text-center pointer pointerRskn"} data-open-modal="FAQModal">
                                    <span className="verizon-icons small Icon--support-drawer text-black block" aria-hidden="true" onClick={(e) => this.onOpenModal(e)} id='FAQ_MOBILE'></span>
                                    <span className="show-for-tiny-only faq-text text-black" onClick={(e) => this.onOpenModal(e)} id='FAQ_MOBILE'>FAQs </span>
                                    <ModalOverlay className="vzicon small text-black middle" template={faqMobLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
                                    <span className="show-for-small-up" style={{ paddingRight: "0.2rem" }}>FAQs </span>
                                    <span className="sr-only">

                                    </span>
                                </div>
                            </li>
                            <li className={(nsiPage || !isEnableSave) ? "hide" : "saveMobile show-for-tiny-only left inline-block tiny-p-20 small-p-auto"}>
                                <div className={isFDVQualified ? isEnableSave ? "alt pointer savecartcta dropSave" : "alt pointer savecartcta dropSave inline-block disabled" : "hide"} id={this.isReskin ? "pointerRskn" : ""} tabIndex={isEnableSave ? "0" : "-1"} role="button">
                                    <span className="verizon-icons small Icon--save" onKeyDown={(e) => this.handleKeyDown(e)} onClick={(e) => this.onOpenModal(e)} id='SAVE_MOBILE'></span>
                                    <span onClick={(e) => this.onOpenModal(e)} id='SAVE_MOBILE' className="save-cart-text text-center block">Save</span>
                                    <ModalOverlay className="verizon-icons small Icon--save text-black middle" template={saveMobLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
                                </div>
                            </li>
                            <li className={(nsiPage || this.isReskin) ? "hide" : "padding-right-micro left"}>
                                <div className="alt text-center pointer">
                                    <span id="aimsChatIcon"></span>
                                    <div id="tc-chat-container-01"></div>
                                </div>
                            </li>
                            <li className={nsiPage ? "hide" : "spanish show-for-tiny-only left inline-block tiny-p-20 small-p-auto"} style={{marginLeft: this.isReskin? '17px' : ''}}  data-equal-width="Nav">
                               {!(sessionStorage.getItem("fiosReferralFlow") === "true") && <a onClick={() => (window.location.hostname === "espanol.verizon.com" || window.location.hostname === "espanolstage.verizon.com") ? this.espanolDomainClick() : this.espanolClick()} id="accordion-spanish" title="switchlanguage" role="button" id={this.isReskin ? "langRskn" : ""}>
                                    <span className={!this.isReskin ? "small espanol-link_mobile text-black" : "small espanol-link_mobile text-black mrLeft"} aria-hidden="true"></span>
                                    <span className="clear text-black block text-center">Espa&ntilde;ol</span>
                                </a>}
                            </li>
                            <li className={nsiPage ? "hide" : "callMobile show-for-tiny-only left tiny-p-20 small-p-auto hide"} id="accordion-callmobile" data-equalwidth="Nav">
                                <div id="showCTCDesktop" data-open-modal="CallMeNowModal" className="alt text-center pointer hide">
                                    <div>
                                        <span className="verizon-icons small Icon--phone text-black middle"></span>
                                        <span onClick={(e) => this.onOpenModal(e)} id='CALLME_MOBILE' className="clear block">Call me</span>
                                        <ModalOverlay className="verizon-icons small Icon--phone text-black middle" template={callMeMobLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
                                    </div>
                                </div>
                            </li>
                            <li className={nsiPage ? "hide" : "TFNMobile left tiny-p-20 small-p-auto hide"} id="accordion-TFNMobile" data-equalwidth="Nav" style={displayNone}>
                                <div id="scbResTFN" className="hide">
                                    <div>
                                        <span className="verizon-icons small Icon--phone text-black middle block"></span>
                                        <p className="clear margin-bottom-zero">Call</p>
                                        <p id="scbspantfn">888-791-1899</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            }
        }

        if(((this.props?.appState.flowType !== 'MV' && this.props?.appState.flowType !== 'SUPP' &&  this.props?.appState?.flowType !== 'AF') || (this.props?.appState.flowType === 'MV' && this.props?.buildProduct?.movesstickyheaderfooter && this.props?.lqState && this.props?.lqState.runtimeKey && this.props?.lqState?.runtimeKey?.enableMovesStickyHeaderFooter === 'Y')) && pathName !== '/inhome/summary' && pathName !== '/inhome/lbo' && pathName !== '/inhome/moves/landing'){
            vzwNCHeaderLayout =<MainSubHeader onOpenModal={(e) => this.onOpenModal(e)} onhandleKeyDownKeyDown={(e) => this.handleKeyDown(e)} isEnableSave={isEnableSave} nsiPage={nsiPage} progressbar={true}/>;
        }
        

        if (isECBuildProductsPage) {
            ecHeaderMsg = <div>
                <div className="promo-ribbon" tabIndex="0">
                    <div className="ribbon-container">
                        Your order is pending. You can still make changes. Some changes may affect your pricing and promotions. Click Cart to see more details.
                </div>
                </div>
            </div>
        }

        if(!this.checkIsHoa()){
            espanolTag =   <a onClick={() => (window.location.hostname === "espanol.verizon.com" || window.location.hostname === "espanolstage.verizon.com") ? this.espanolDomainClick() : this.espanolClick()} title="switchlanguage" className={this.isMonarch ? "espanol-link_monarch espanol-link" : "espanol-link"} tabIndex="0" onKeyDown={(e) => this.handleEsponolKeyDown(e)}>Español </a>
                        
        }
        else if(this.checkIsHoa()){
            espanolTag =   <a onClick={() => (window.location.hostname === "espanol.verizon.com" || window.location.hostname === "espanolstage.verizon.com") ? this.espanolDomainClick() : this.espanolClick()} title="switchlanguage" className={this.isMonarch ? "espanol-link_monarch espanol-link" : "espanol-link"} tabIndex="0" onKeyDown={(e) => this.handleEsponolKeyDown(e)}>Español </a>
                        
        }

        if(sessionStorage.getItem("fiosReferralFlow") === "true" && window?.location?.href?.includes('fiosreferral')) {
            espanolTag = <button style={{float:"right",marginTop:"15px"}} onClick={()=>this.swtichLang()}>{window.location.hostname === "espanol.verizon.com" || window.location.hostname === "espanolstage.verizon.com" ? 'English': 'Español' }</button>
        } else if(sessionStorage.getItem("fiosReferralFlow") === "true" && !window?.location?.href?.includes('fiosreferral')) {
            espanolTag = null;
        }

        return (
            <React.Fragment>
                {/* Header for EC Flow*/}
                <div className={`${showGNAV && fiosReferral !== "true" ? '' : 'hide'}`} id="vz-gh20"></div>
                <div className={`${isECBuildProductsPage ? '' : 'hide'}`}>
                    {/* {ecHeaderMsg} */}
                </div>
                {/* Header for NC and Moves Flow*/}
                 <div id="fiosHeaderLq" className={this.props.lqState.mfrtHeaderhide ? 'w_header_tws_milvet bg-black':( window.location?.pathname?.indexOf('/change/') > -1 && window.screen.width < 360 ? "hide" : `${isProgressBar || (isStickyFooterCartOpen && this.props?.appState?.flowType ==='MV')  ? '' : 'w_header'} bg-black ${!showGNAV ? '' : 'hide'} ${hideHeaderForSuspendServices ? 'hide' : ''} `)} role='navigation'>
                    <GlobalChat />
                    {sweetnerMsg}      
                                       
                    <div className={(isSummaryPage||isLBO) ? `header_wrapper_summary`: this.isReskin ? `header_wrapper header_wrapper_reskin ${this.isMonarch ? 'header_wrapper_monarch' : ''}` : `header_wrapper ${this.isMonarch ? 'header_wrapper_monarch' : ''}`}>
                     <div className={`${this. checkIsHoa() ? 'test-head-hoa':'test-head'} ${this.hideVzHeaderBlock? 'hide':''} ${(this?.props?.isCartOpen && (this.props?.appState?.flowType === 'MV' || this.props?.appState?.flowType === 'NC')) || sessionStorage.getItem("fiosReferralFlow") === "true" ? "hide" : ""}`} 
                     style={{display: isStickyFooterCartOpen  && isProgressBar &&  'none'}}>
                        <div className="smc-wrapper">
                            <a className="skip-main-content"  tabIndex="0" href="#main-content" id="setFocusToMainContent">
                            { isStreamline ? '' : <span>Skip to main content</span>}
                            </a>
                        </div> 
                        <div className={pathName.indexOf("inhome/brtc") > -1?"hide":"show-for-medium-up padding-right-large"}>
                          {espanolTag}
                        </div>
                        {this. checkIsHoa()? <hr  className='custom-hr'/>:''} 
                        <div className={((vendorFlow && !vendorVZLogo)  || isNCMVAppFlow) ? "hide" : `${this.isMonarch ? streamlinePage ? 'vz_logo_monarch vzLogoMarginLeft' :'vz_logo_monarch' : 'vz_logo'}`}>
                            <a aria-label="Verizon Logo on click redirect to fios-fast-internet" role="button" tabIndex="0" onClick={(e) => this.homeClick(e, vendorVZLogo, this.props.appState.flowType)}> </a>
                        </div>
                        <div className={((vendorFlow && !vendorVZLogo) || isNCMVAppFlow) ? `${this.isMonarch ? 'vz_logo_monarch' : 'vz_logo'}` : "hide"}>
                            {/* <img className={isTargetOrdering?"":"hide"}  src={require('./../../assets/ak-cached/24h/img/fios-logo.png')} alt="Verizon Wireless Logo"/> */}
                            <a className={isTargetOrdering || isNCMVAppFlow ? "hide" : `${this.isMonarch ? 'vz_logo_monarch' : 'vz_logo'}`} title="Verizon Logo" aria-label="Verizon Logo" tabIndex="0" onClick={(e) => this.vendorClick(e, isTargetOrdering)}>
                                {/* <img src={require('./../../assets/ak-cached/24h/img/fios-logo.png')} alt="Verizon Wireless Logo"/> */}
                            </a>
                        </div>
                        <div className={(vendorFlow && needHelp && vednorTN !== "") ? "callUs" : "hide"}>
                            <div className="left p-100" onClick={this.vednorTNClick}>
                                <div className="left"><span className={`vzicon icon-calls ${this.isMonarch ? 'text-black' : 'text-white'} inline-block`} title="Call Us" aria-hidden="true"></span></div>
                                <div className="left p-80 show-for-small-up">
                                    <div className="text-medium padding-left-micro">Need help picking the perfect package? Call us.<span className="call-verizon_number text-small bold">{vednorTN}</span></div>
                                </div>
                            </div>
                        </div>
                        {/* <div className={vendorFlow && vednorTN === "" ? "callUs" : "hide"}>
                            <div className="left p-100">
                                <div className="left"><span className="vzicon icon-calls text-white inline-block" title="Call Us" aria-hidden="true"></span></div>
                            </div>
                        </div> */}
                        <div className="w_topnav">
                            <div className={(isTargetOrdering || isNCMVAppFlow) ? "hide" : `${this.isMonarch ? 'vz_mobilelogo_monarch' : 'vz_mobilelogo' }`}>
                                {
                                    (isTargetOrdering || isNCMVAppFlow) ? null :
                                        (vendorFlow && !vendorVZLogo) ?
                                            <a title="Verizon Logo" tabIndex="0" role="button" onClick={(e) => this.vendorClick(e, isTargetOrdering)} aria-label="Verizon Logo">  </a>
                                            // : <a title="Verizon Logo" tabIndex="0" role="button" onClick={(e) => this.homeClick(e, null, this.props.appState.flowType)} aria-label="Verizon Logo"> </a>
                                            : !isSupLboMvaFlow ? <a title="Verizon Logo" tabIndex="0" role="button" onClick={(e) => this.homeClick(e, null, this.props.appState.flowType)} aria-label="Verizon Logo"> </a> : null
                                }
                                {/* <a title="Verizon Wireless Logo" tabIndex="0" role="button" onClick={(e)=>this.homeClick(e,null,this.props.appState.flowType)}> </a> */}
                            </div>
                            {navLinks}
                        </div>
                    {/* </div> */}
                   
                    
                    </div> 
                    { <div id="minCartOS" className="topnav_userlinks">                        
                            <div className="w_topnavmini">
                            <div className="more left inline-block topnav_cart" >
                        { (this.props.isCartOpen && InHomeUtils.isNotNull(this.props.cartData) && this.props.appState.flowType !=='SUPP') ? <OrderSummary progressbar={true} /> : '' }
                        </div>
                       
                        </div> 
                    </div> 
                    } 
                    <a id="skipped-main-content" href="#main-content" className={this?.props?.isCartOpen ? "hide" : "" }></a>
                    {vzwHeader}
                    <div id="fiosLqIntegration"></div>
                    {sweetnerMsgMFRT}
                    {vzcCouponNotificationMsg}
                    
                </div>
                
             </div>
             {vzwNCHeaderLayout}
             
            </React.Fragment>
        );
    }
}

const DOMAINS = {
    PROD: "www.verizon.com",
    PILOT: "wwwordering-pilot-east-yz.ebiz.verizon.com",
    PREPROD: "preprod-east-gz.vpc.verizon.com",
    STAGE: "www98.verizon.com",
    SIT: "wwwawssit.ebiz.verizon.com",
    UAT: "wwwawsuat.ebiz.verizon.com",
    NTE1: "wwwnte1aws.ebiz.verizon.com",
    NTE3: "wwwnte3aws.ebiz.verizon.com",
    NTE4: "wwwnte4aws.ebiz.verizon.com",
    NTE5: "wwwnte5aws.ebiz.verizon.com",
    ESPANOL: "espanol.verizon.com"
}

const mapStateToProps = (state) => {
    return {
        modalWindow: state.modalWindow,
        isFlashOfferApplied: state.buildProduct.flashoffer && state.buildProduct.flashoffer.selectedProduct || null, //Added flashoffer truthyness, to avoid DOM breakage in firefox-Mac
        internetProduct: state.buildProduct.internet,
        servicesQualified: state.loopQual.servicesQualified,
        tvProduct: state.buildProduct.tv,
        faqBuildProduct: state.buildProduct.faqBuildProductContent,
        faqCheckout: state.checkout.faqCheckoutContent,
        faqNsi: state.nsi.faqNsiNotificationContent,
        faqMoveLanding: state.moveExp.faqMoveLandingContent,
        vzwOffer: state.loopQual.vzwOffer,
        appState: state.app,
        save: state.save,
        creditCheckResponse: state.creditCheck.creditCheckResponse,
        personalInfo: state.personalInfo.contactInfo,
        cartOrderDetail: state.cart.cartOrderDetail,
        cartData: state.cart.cartData,
        cartResponse: state.cart.cartResponse,
        isCartOpen:state.cart.isCartOpen,
        moveState: state.moveExp,        
        couponFlowType: state.loopQual.couponFlowType,
        lqState: state.loopQual,
        isFCPflow: state.loopQual.isFCPflow,
        runtimeKey : state.loopQual.runtimeKey,
        SweetnerMsg: state.buildProduct.SweetnerMsg,
        SweetnerMsgMFRT: state.loopQual.sweetnerMsgMFRT,
        MFRTEligible: state.loopQual.MFRTEligible,
        vzcCouponInfo: state.buildProduct.vzcCouponInfo,
        signIn: state.signIn,
        buildProduct : state.buildProduct,
        router: state.router
    }
}

export default withCookies(connect(
    mapStateToProps,
)(Header));